<template>
  <vx-card>
    <div>
      <div class="vx-row mb-6 w-full">
        <div class="vx-col mb-6 w-full">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Shipment Doc</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <div class="vx-col w-1/2">
                <vs-input
                  class="w-full"
                  v-model="table.data.shipment_number"
                  :disabled="true"
                  v-validate="'required'"
                />
              </div>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Customer Data</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <div class="vx-col w-1/2">
                <vs-input
                  class="w-full"
                  v-model="table.data.customer_code"
                  :disabled="true"
                  v-validate="'required'"
                />
              </div>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>SO Data</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <div class="vx-col w-1/2">
                <vs-input
                  class="w-full"
                  v-model="table.data.sales_order_code"
                  :disabled="true"
                  v-validate="'required'"
                />
              </div>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>DO Data</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <div class="vx-col w-1/2">
                <vs-input
                  class="w-full"
                  v-model="table.data.delivery_order_code"
                  :disabled="true"
                  v-validate="'required'"
                />
              </div>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>POD Date</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <div class="vx-col w-1/2">
                <vs-input
                  class="w-full"
                  v-model="table.data.proof_of_delivery_date"
                  type="date"
                  :max="dateNow"
                  :min="table.data.delivery_date"
                  v-validate="'required'"
                  @input="validatePodDate"
                  @keydown.prevent
                  @paste.prevent
                />
                <span class="text-danger text-sm" v-show="podDateError">{{
                  podDateError
                }}</span>
              </div>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>POD Status</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <div class="vx-col w-1/2">
                <multiselect
                  class="selectExample"
                  v-model="selectedStatus"
                  :options="optionalStatus"
                  :disabled="editOrShow"
                  :multiple="false"
                  :allow-empty="false"
                  :group-select="false"
                  :max-height="100"
                  :limit="3"
                  placeholder="Select one"
                  :searchable="true"
                  :custom-label="customLabelStatus"
                  @select="handleSelectStatus()"
                />
              </div>
            </div>
          </div>
          <div
            class="vx-row mb-6"
            v-if="selectedStatus.ID == 4 || selectedStatus.ID == 5"
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span>Reason</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <div class="vx-col w-1/2">
                <multiselect
                  class="selectExample"
                  v-model="selectedReason"
                  :options="optionReason"
                  :disabled="editOrShow"
                  :multiple="false"
                  :allow-empty="false"
                  :group-select="false"
                  :max-height="100"
                  :limit="3"
                  placeholder="Select one"
                  :searchable="true"
                  track-by="id"
                  label="reason"
                  name="reason"
                  @select="handleSelectReason()"
                />
                <span class="text-danger text-sm" v-show="errors.has('reason')"
                  >Reason is required</span
                >
              </div>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Document</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <div class="vx-col w-1/2">
                <vs-checkbox
                  v-model="table.data.is_document"
                  color="success"
                  :disabled="editOrShow"
                />
              </div>
            </div>
          </div>

          <!-- Detail E-POD Button -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Details E-POD</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <div class="vx-col w-1/2">
                <vs-button v-on:click="handleDetailsEpod()" color="primary">
                  {{ showDetailVisit ? "Close Detail" : "Detail E-POD" }}
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Detail Visit Section - Toggled by showDetailVisit -->
      <div class="vx-row mb-6 w-full" v-if="showDetailVisit">
        <!-- Map Section - Full Width -->
        <div class="vx-col w-full">
          <!-- Map Section -->
          <div class="epod-map-section">
            <div class="epod-map-header">
              <div class="flex items-center gap-2">
                <span class="epod-photo-icon">🗺️</span>
                <span class="epod-photo-title">Delivery Locations Map</span>
              </div>

              <!-- Toggle untuk map type - tampil jika ada data location atau route -->
              <div
                v-if="hasValidLocationData || hasValidRouteData"
                class="epod-map-controls"
              >
                <vs-button
                  size="small"
                  @click="showRouteMap = false"
                  :color="!showRouteMap ? 'primary' : 'dark'"
                  :type="!showRouteMap ? 'filled' : 'border'"
                  :disabled="!hasValidLocationData"
                >
                  📍 Location
                </vs-button>
                <vs-button
                  size="small"
                  @click="showRouteMap = true"
                  :color="showRouteMap ? 'primary' : 'dark'"
                  :type="showRouteMap ? 'filled' : 'border'"
                  :disabled="!hasValidRouteData"
                >
                  🛣️ Route
                </vs-button>
              </div>
            </div>

            <!-- Radius Status Indicator -->
            <div
              v-if="
                isOutsideRadius !== null &&
                (hasValidLocationData || hasValidRouteData)
              "
              class="epod-radius-status"
              :class="isOutsideRadius ? 'status-outside' : 'status-inside'"
            >
              <span v-if="isOutsideRadius" class="status-icon">⚠️</span>
              <span v-else class="status-icon">✅</span>
              <span class="status-text">
                {{ isOutsideRadius ? "Out of Radius" : "In Radius" }}
              </span>
            </div>

            <!-- Map components dengan conditional rendering -->
            <div class="epod-map-content">
              <!-- Kondisi jika ada data location -->
              <div v-if="hasValidLocationData || hasValidRouteData">
                <!-- Single Location Map -->
                <div v-if="!showRouteMap && hasValidLocationData">
                  <MapViewer
                    :latitude="locationData.latitude"
                    :longitude="locationData.longitude"
                    :accuracy="locationData.accuracy"
                    :timestamp="locationData.location_timestamp"
                    :address="locationData.location_address"
                    :height="'350px'"
                    :customer-location="customerLocation"
                    :distance-between-customer-and-visit="
                      distanceBetweenCustomerAndVisit
                    "
                  />
                </div>

                <!-- Route Map -->
                <div v-else-if="showRouteMap && hasValidRouteData">
                  <RouteMapViewer
                    :origin="routeDataComputed.origin"
                    :destination="routeDataComputed.destination"
                    :customer-location="customerLocation"
                    :height="'350px'"
                    :route-color="'#3b82f6'"
                    :route-weight="4"
                  />
                </div>

                <!-- Fallback ke location map jika route data tidak lengkap -->
                <div v-else-if="hasValidLocationData">
                  <div class="mb-2 text-sm text-amber-600">
                    ⚠️ Route data incomplete, showing location only
                  </div>
                  <MapViewer
                    :latitude="locationData.latitude"
                    :longitude="locationData.longitude"
                    :accuracy="locationData.accuracy"
                    :timestamp="locationData.location_timestamp"
                    :address="locationData.location_address"
                    :height="'350px'"
                  />
                </div>
              </div>

              <!-- Kondisi jika tidak ada data location dan route -->
              <div
                v-else
                class="w-full h-80 bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 flex flex-col items-center justify-center text-gray-500"
              >
                <feather-icon
                  icon="MapIcon"
                  class="text-4xl mb-3 text-gray-400"
                />
                <p class="text-sm font-medium">No Location Data Available</p>
                <p class="text-xs text-center mt-1">
                  GPS coordinates have not been recorded yet
                </p>
                <div
                  class="mt-3 px-3 py-1 bg-gray-100 text-gray-600 rounded-full text-xs"
                >
                  📍 Location Tracking Disabled
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Photos Section - Full Width Row -->
      <div class="vx-row mb-6 w-full" v-if="showDetailVisit">
        <div class="vx-col w-full">
          <!-- Photo Grid Container -->
          <div class="epod-photos-grid">
            <!-- Visit Photo Card -->
            <div class="epod-photo-card">
              <div class="epod-photo-header">
                <div class="flex items-center gap-2">
                  <span class="epod-photo-icon">🚚</span>
                  <span class="epod-photo-title">Visit Photo</span>
                </div>
                <span class="epod-badge epod-badge-green">Arrival</span>
              </div>

              <div
                v-if="visitPhotoUrl"
                class="epod-photo-wrapper"
                @click="openPhotoModal('visit', visitPhotoUrl)"
              >
                <img
                  :src="visitPhotoUrl"
                  alt="Visit Photo"
                  class="epod-photo-img"
                  loading="lazy"
                />
                <div class="epod-photo-overlay">
                  <feather-icon icon="ZoomInIcon" class="epod-zoom-icon" />
                  <span class="epod-overlay-text">Click to enlarge</span>
                </div>
              </div>

              <div v-else class="epod-photo-empty">
                <feather-icon icon="CameraIcon" class="epod-empty-icon" />
                <p class="epod-empty-text">No photo available</p>
              </div>
            </div>

            <!-- COD Photo Card -->
            <div class="epod-photo-card">
              <div class="epod-photo-header">
                <div class="flex items-center gap-2">
                  <span class="epod-photo-icon">💰</span>
                  <span class="epod-photo-title">COD Photo</span>
                </div>
                <span class="epod-badge epod-badge-yellow">Payment</span>
              </div>

              <div
                v-if="codPhotoUrl"
                class="epod-photo-wrapper"
                @click="openPhotoModal('cod', codPhotoUrl)"
              >
                <img
                  :src="codPhotoUrl"
                  alt="COD Photo"
                  class="epod-photo-img"
                  loading="lazy"
                />
                <div class="epod-photo-overlay">
                  <feather-icon icon="ZoomInIcon" class="epod-zoom-icon" />
                  <span class="epod-overlay-text">Click to enlarge</span>
                </div>
              </div>

              <div v-else class="epod-photo-empty">
                <feather-icon icon="DollarSignIcon" class="epod-empty-icon" />
                <p class="epod-empty-text">No photo available</p>
              </div>
            </div>

            <!-- POD Photo Card -->
            <div class="epod-photo-card">
              <div class="epod-photo-header">
                <div class="flex items-center gap-2">
                  <span class="epod-photo-icon">📦</span>
                  <span class="epod-photo-title">POD Photo</span>
                </div>
                <span class="epod-badge epod-badge-blue">Delivery</span>
              </div>

              <div
                v-if="podPhotoUrl"
                class="epod-photo-wrapper"
                @click="openPhotoModal('pod', podPhotoUrl)"
              >
                <img
                  :src="podPhotoUrl"
                  alt="POD Photo"
                  class="epod-photo-img"
                  loading="lazy"
                />
                <div class="epod-photo-overlay">
                  <feather-icon icon="ZoomInIcon" class="epod-zoom-icon" />
                  <span class="epod-overlay-text">Click to enlarge</span>
                </div>
              </div>

              <div v-else class="epod-photo-empty">
                <feather-icon icon="PackageIcon" class="epod-empty-icon" />
                <p class="epod-empty-text">No photo available</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Photo Modal -->
      <vs-popup class="epod-photo-modal" title="" :active.sync="showPhotoModal">
        <div class="epod-modal-container">
          <div class="epod-modal-header">
            <h3 class="epod-modal-title">
              {{
                selectedPhotoType === "visit"
                  ? "🚚 Visit Photo"
                  : selectedPhotoType === "cod"
                  ? "💰 COD Photo"
                  : "📦 POD Photo"
              }}
            </h3>
            <vs-button
              @click="closePhotoModal"
              size="small"
              color="dark"
              type="border"
              icon-pack="feather"
              icon="icon-x"
              class="epod-close-btn"
            />
          </div>

          <div class="epod-modal-content">
            <div class="epod-modal-image-wrapper">
              <img
                :src="selectedPhotoUrl"
                :alt="selectedPhotoType + ' photo'"
                class="epod-modal-image"
              />
            </div>

            <div class="epod-modal-controls">
              <vs-button
                @click="openImageInNewTab"
                color="primary"
                icon-pack="feather"
                icon="icon-external-link"
              >
                Open in New Tab
              </vs-button>
              <vs-button
                @click="downloadImage"
                color="success"
                icon-pack="feather"
                icon="icon-download"
              >
                Download
              </vs-button>
            </div>

            <div class="epod-modal-info">
              <div class="epod-info-badge">
                📅 {{ formatPhotoTime(new Date()) }}
              </div>
            </div>
          </div>
        </div>
      </vs-popup>

      <br />
      <hr />
      <div class="vx-row flex justify-between mt-5 m-10">
        <div class="flex flex-row justify-between gap-2">
          <vs-button
            class="mb-2"
            v-on:click="SubmitForm(false)"
            v-if="!editOrShow && calculatePromotion"
            :disabled="prosessingSave"
          >
            Save
          </vs-button>
          <vs-button
            class="mb-2"
            v-on:click="SubmitForm(true)"
            :disabled="prosessingSave"
            v-if="!editOrShow && calculatePromotion"
          >
            Process
          </vs-button>
          <vs-button
            class="mb-2"
            v-on:click="handleCalculatePromotion"
            :disabled="prosessingSave"
            v-if="!editOrShow && !calculatePromotion"
          >
            Calculate
          </vs-button>
        </div>
        <div>
          <vs-button
            class="mb-2"
            :disabled="prosessingSave"
            v-on:click="handleClose()"
            >Close</vs-button
          >
        </div>
      </div>
      <div v-if="itemLine.length > 0" class="separator">
        <span>REGULER</span>
      </div>
      <vs-table
        v-if="itemLine.length > 0"
        stripe
        border
        description
        :sst="true"
        :data="itemLine"
        :max-items="itemLine.length"
      >
        <template slot="thead">
          <vs-th style="width: 28%">SKU Name</vs-th>
          <vs-th style="width: 12%">SKU Code</vs-th>
          <vs-th style="width: 5%">Quantity</vs-th>
          <vs-th style="width: 10%">Accepted Quantity</vs-th>
          <vs-th style="width: 5%">Full Rejected</vs-th>
          <vs-th style="width: 30%">Rejected Quantity</vs-th>
          <vs-th style="width: 10%">Note</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.item_name">
              {{ tr.item_name }}
              <br />
              <span v-if="tr.allow_partial" class="text-lg text-success"
                >Allow Partial</span
              >
            </vs-td>
            <vs-td :data="tr.item_code">
              {{ tr.item_code }}
            </vs-td>
            <vs-td :data="tr.quantity">
              {{ tr.quantity }}-{{ tr.item_unit }}
            </vs-td>
            <vs-td>
              <!-- <div class="vx-row">
                <vs-input
                  class="w-2/3"
                  v-model="tr.adjusted_quantity"
                  disabled
                  type="number"
                />
                <vs-input
                  class="w-1/3"
                  v-model="tr.accepted_item.unit_name"
                  disabled
                />
              </div> -->
              <!-- Display converted units -->
              <div
                v-if="tr.note_accepted && tr.note_accepted.length > 0"
                class="accepted-quantity-container mt-2"
              >
                <div
                  v-for="(unit, idx) in tr.note_accepted"
                  :key="idx"
                  class="quantity-badge"
                >
                  <span class="quantity-number">{{ unit.quantity }}</span>
                  <span class="quantity-unit">{{ unit.unit_name }}</span>
                </div>
              </div>
            </vs-td>
            <vs-td>
              <div class="vx-row">
                <vs-switch
                  color="success"
                  icon-pack="feather"
                  v-model="tr.is_all_batch"
                  :disabled="disableRejectAndAccept"
                  @change="handleAllBatch(tr, tr.item_id, index, null)"
                >
                  <span slot="on">Active</span>
                  <span slot="off">Inactive</span>
                </vs-switch>
              </div>
            </vs-td>
            <vs-td>
              <div
                class="w-full flex justify-end gap-2"
                v-for="(tk, index) in RejectedReason.filter(
                  (reason) =>
                    reason.item_id === tr.item_id &&
                    reason.is_reguler &&
                    reason.item_unit === tr.item_unit
                ).flatMap((reason) => reason.hu_rejected)"
                :key="index"
                :data="tk"
              >
                <div class="w-3/4 flex flex-col justify-end">
                  <div class="w-full flex flex-row justify-end gap-10">
                    <span>HU:</span>
                    <multiselect
                      class="selectExample"
                      v-model="tk.hu"
                      :options="tr.item_units"
                      :multiple="false"
                      :allow-empty="true"
                      :group-select="false"
                      :max-height="100"
                      :limit="3"
                      placeholder="Select one"
                      :searchable="true"
                      track-by="id"
                      label="unit_name"
                      :disabled="disableRejectAndAccept || !tr.allow_partial"
                      @select="selectHU(tr, tr.item_id, index, tk)"
                    />
                  </div>
                  <div class="w-full flex flex-row justify-end gap-4">
                    <span>Batch:</span>
                    <multiselect
                      class="selectExample"
                      v-model="tk.batches"
                      :options="tk.list_batch"
                      :multiple="false"
                      :allow-empty="true"
                      :group-select="false"
                      :max-height="100"
                      :limit="3"
                      placeholder="Select one"
                      :searchable="true"
                      track-by="delivery_order_line_id"
                      :custom-label="customLabelBatch"
                      :disabled="disableRejectAndAccept || !tr.allow_partial"
                      @select="selectBatch(tr, tr.item_id, tk)"
                    />
                  </div>
                  <div class="w-full flex flex-row justify-end gap-10">
                    <span class="w-1/8">Qty:</span>
                    <vs-input
                      class="w-full"
                      v-model="tk.quantity"
                      :disabled="disableRejectAndAccept || !tr.allow_partial"
                      type="number"
                      :min="0"
                      @input="rejectedCheck(tr, tr.item_id, tk)"
                    />
                  </div>
                  <div class="w-full flex flex-row justify-end gap-2">
                    <span>Reason:</span>

                    <multiselect
                      class="selectExample"
                      v-model="tk.reason"
                      :options="optionReason"
                      :multiple="false"
                      :allow-empty="true"
                      :group-select="false"
                      :max-height="100"
                      :limit="3"
                      placeholder="Select one"
                      :searchable="true"
                      track-by="id"
                      label="reason"
                      :disabled="disableRejectAndAccept"
                    />
                  </div>
                  <br
                    v-if="
                      RejectedReason.filter(
                        (reason) =>
                          reason.item_id === tr.item_id &&
                          reason.is_reguler &&
                          reason.item_unit === tr.item_unit
                      ).flatMap((reason) => reason.hu_rejected).length > 1
                    "
                  />
                </div>
                <div class="vx-col w-1/4 flex flex-col justify-center">
                  <div class="vx-input-group flex">
                    <vs-button
                      v-if="
                        RejectedReason.filter(
                          (reason) =>
                            reason.item_id === tr.item_id &&
                            reason.is_reguler &&
                            reason.item_unit === tr.item_unit
                        ).flatMap((reason) => reason.hu_rejected).length > 1 &&
                        !disableRejectAndAccept &&
                        tr.allow_partial
                      "
                      @click.stop="removeRowReason(tr.item_id, index, tk, tr)"
                      size="small"
                      color="danger"
                      icon-pack="feather"
                      icon="icon-trash"
                      style="margin-right: 5px"
                      title="Remove Row"
                    />

                    <vs-button
                      v-if="!disableRejectAndAccept && tr.allow_partial"
                      @click.stop="addRowReason(tr.item_id, index, tk, tr)"
                      size="small"
                      color="success"
                      icon-pack="feather"
                      icon="icon-plus"
                      title="Add Row"
                    />
                  </div>
                </div>
              </div>
            </vs-td>
            <vs-td>
              <div>
                <vs-input
                  class="w-full"
                  v-model="tr.notes"
                  :disabled="disabledReason"
                  type="text"
                />
              </div>
            </vs-td>
          </vs-tr>
          <tr
            v-for="index in addTr"
            :key="index"
            style="background: transparent"
          >
            <td></td>
          </tr>
        </template>
      </vs-table>

      <div v-if="itemCombo.length > 0" class="separator">
        <span>COMBO</span>
      </div>
      <div v-if="ComboMaster.length > 0" class="w-full">
        <vs-table
          stripe
          border
          description
          :sst="true"
          :data="ComboMaster"
          :max-items="ComboMaster.length"
        >
          <template slot="thead">
            <vs-th style="width: 10%">Combo Code</vs-th>
            <vs-th style="width: 5%">Quantity Total</vs-th>
            <vs-th style="width: 5%">Accepted Quantity</vs-th>
            <vs-th style="width: 5%">Rejected Quantity</vs-th>
            <vs-th style="width: 15%">Reason </vs-th>
            <vs-th style="width: 5%">Action</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="combo_id" v-for="(tr, combo_id) in data">
              <vs-td :data="tr.combo_code">
                {{ tr.combo_code }}
              </vs-td>
              <vs-td :data="tr.combo_quantity_real">
                <vs-input
                  class="w-2/3"
                  v-model="tr.combo_quantity_real"
                  disabled
                  type="number"
                />
              </vs-td>
              <vs-td :data="tr.combo_quantity_accepted">
                <vs-input
                  class="w-2/3"
                  v-model="tr.combo_quantity_accepted"
                  disabled
                  type="number"
                />
              </vs-td>
              <vs-td>
                <div class="vx-row">
                  <vs-input
                    class="w-2/3"
                    v-model="tr.combo_quantity_rejected"
                    type="number"
                    @input="rejectedComboCheck(combo_id, tr.combo_id)"
                    :disabled="disableRejectAndAccept"
                  />
                </div>
              </vs-td>
              <vs-td>
                <multiselect
                  class="selectExample"
                  v-model="tr.reason"
                  :options="optionReason"
                  :multiple="false"
                  :allow-empty="true"
                  :group-select="false"
                  :max-height="100"
                  :limit="3"
                  placeholder="Select one"
                  :searchable="true"
                  track-by="id"
                  label="reason"
                  @select="rejectedComboCheckReason(combo_id, tr.combo_id)"
                  :disabled="disableRejectAndAccept"
                />
              </vs-td>
              <vs-td>
                <vs-button
                  v-if="!isDetailCombo"
                  @click.stop="handleDetailsCombo(tr.combo_id)"
                  size="small"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-eye"
                  title="Details"
                />
                <vs-button
                  v-if="isDetailCombo"
                  @click.stop="handleDetailsCombo(tr.combo_id)"
                  size="small"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-eye-off"
                  title="Details"
                />
              </vs-td>
            </vs-tr>
            <br />
            <br />
            <br />
            <br />
            <tr
              v-for="index in addTr"
              :key="index"
              style="background: transparent"
            >
              <td></td>
            </tr>
          </template>
        </vs-table>
      </div>
      <vs-table
        v-if="detailCombo.length > 0 && isDetailCombo"
        stripe
        border
        description
        :sst="true"
        :data="detailCombo"
        :max-items="detailCombo.length"
      >
        <template slot="thead">
          <vs-th style="width: 28%">SKU Name</vs-th>
          <vs-th style="width: 12%">SKU Code</vs-th>
          <vs-th style="width: 5%">Quantity</vs-th>
          <vs-th style="width: 10%">Accepted Quantity</vs-th>
          <vs-th style="width: 30%">Rejected Quantity</vs-th>
          <vs-th style="width: 15%">Note</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="'cn' + indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.item_name">
              {{ tr.item_name }}
            </vs-td>
            <vs-td :data="tr.item_code">
              {{ tr.item_code }}
            </vs-td>
            <vs-td :data="tr.quantity">
              {{ tr.quantity }}-{{ tr.item_unit }}
            </vs-td>
            <vs-td>
              <div
                v-if="tr.note_accepted && tr.note_accepted.length > 0"
                class="accepted-quantity-container"
              >
                <div
                  v-for="(unit, idx) in tr.note_accepted"
                  :key="idx"
                  class="quantity-badge"
                >
                  <span class="quantity-number">{{ unit.quantity }}</span>
                  <span class="quantity-unit">{{ unit.unit_name }}</span>
                </div>
              </div>
              <div v-else class="text-muted">-</div>
            </vs-td>
            <vs-td>
              <div
                class="w-full flex justify-start gap-2"
                v-for="(ty, index) in RejectedReason.filter(
                  (reason) =>
                    reason.item_id === tr.item_id &&
                    reason.is_combo &&
                    reason.item_unit === tr.item_unit &&
                    reason.combo_id === tr.combo_id
                ).flatMap((reason) => reason.hu_rejected)"
                :key="index"
                :data="ty"
              >
                <div class="w-3/4 flex flex-col justify-end">
                  <div class="w-full flex flex-row justify-end gap-10">
                    <span>HU:</span>
                    <multiselect
                      class="selectExample"
                      v-model="ty.hu"
                      :options="tr.item_units"
                      :multiple="false"
                      :allow-empty="true"
                      :group-select="false"
                      :max-height="100"
                      :limit="3"
                      placeholder="Select one"
                      :searchable="true"
                      track-by="id"
                      label="unit_name"
                      disabled
                    />
                  </div>
                  <div class="w-full flex flex-row justify-end gap-10">
                    <span class="w-1/8">Qty:</span>
                    <vs-input
                      class="w-full"
                      v-model="ty.quantity"
                      disabled
                      type="number"
                    />
                  </div>
                  <div class="w-full flex flex-row justify-end gap-2">
                    <span>Reason:</span>

                    <multiselect
                      class="selectExample"
                      v-model="ty.reason"
                      :options="optionReason"
                      :multiple="false"
                      :allow-empty="true"
                      :group-select="false"
                      :max-height="100"
                      :limit="3"
                      placeholder="Select one"
                      :searchable="true"
                      track-by="id"
                      label="reason"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </vs-td>
            <vs-td>
              <div>
                <vs-input
                  class="w-full"
                  v-model="tr.notes"
                  disabled
                  type="text"
                />
              </div>
            </vs-td>
          </vs-tr>
          <tr
            v-for="index in addTr"
            :key="index"
            style="background: transparent"
          >
            <td></td>
          </tr>
        </template>
      </vs-table>

      <div v-if="itemFree.length > 0" class="separator">
        <span>FREE</span>
      </div>
      <vs-table
        v-if="itemFree.length > 0"
        stripe
        border
        description
        :sst="true"
        :data="itemFree"
        :max-items="itemFree.length"
      >
        <template slot="thead">
          <vs-th style="width: 28%">SKU Name</vs-th>
          <vs-th style="width: 12%">SKU Code</vs-th>
          <vs-th style="width: 5%">Quantity</vs-th>
          <vs-th style="width: 10%">Accepted Quantity</vs-th>
          <vs-th style="width: 5%">Full Rejected</vs-th>
          <vs-th style="width: 30%">Rejected Quantity</vs-th>
          <vs-th style="width: 10%">Note</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="'kk' + indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.item_name">
              {{ tr.item_name }}
            </vs-td>
            <vs-td :data="tr.item_code">
              {{ tr.item_code }}
            </vs-td>

            <vs-td :data="tr.quantity">
              {{ tr.quantity }}-{{ tr.item_unit }}
            </vs-td>
            <vs-td>
              <!-- <div class="vx-row">
                <vs-input
                  class="w-2/3"
                  v-model="tr.adjusted_quantity"
                  disabled
                  type="number"
                />
                <vs-input
                  class="w-1/3"
                  v-model="tr.accepted_item.unit_name"
                  disabled
                />
              </div> -->
              <!-- Display converted units -->
              <div
                v-if="tr.note_accepted && tr.note_accepted.length > 0"
                class="accepted-quantity-container mt-2"
              >
                <div
                  v-for="(unit, idx) in tr.note_accepted"
                  :key="idx"
                  class="quantity-badge"
                >
                  <span class="quantity-number">{{ unit.quantity }}</span>
                  <span class="quantity-unit">{{ unit.unit_name }}</span>
                </div>
              </div>
            </vs-td>
            <vs-td>
              <div class="vx-row">
                <vs-switch
                  color="success"
                  icon-pack="feather"
                  v-model="tr.is_all_batch"
                  disabled
                  @change="handleAllBatch(tr, tr.item_id, index, null)"
                >
                  <span slot="on">Active</span>
                  <span slot="off">Inactive</span>
                </vs-switch>
              </div>
            </vs-td>
            <vs-td>
              <div
                class="w-full flex justify-end gap-2"
                v-for="(ts, index) in RejectedReason.filter(
                  (reason) =>
                    reason.item_id === tr.item_id &&
                    reason.is_free &&
                    reason.item_unit === tr.item_unit
                ).flatMap((reason) => reason.hu_rejected)"
                :key="index"
                :data="ts"
              >
                <div class="w-3/4 flex flex-col justify-end">
                  <div class="w-full flex flex-row justify-end gap-10">
                    <span>HU:</span>
                    <multiselect
                      class="selectExample"
                      v-model="ts.hu"
                      :options="tr.item_units"
                      :multiple="false"
                      :allow-empty="true"
                      :group-select="false"
                      :max-height="100"
                      :limit="3"
                      placeholder="Select one"
                      :searchable="true"
                      track-by="id"
                      label="unit_name"
                      disabled
                      @select="selectHU(tr, tr.item_id, index, ts)"
                    />
                  </div>
                  <div class="w-full flex flex-row justify-end gap-4">
                    <span>Batch:</span>
                    <multiselect
                      class="selectExample"
                      v-model="ts.batches"
                      :options="tr.batches"
                      :multiple="false"
                      :allow-empty="true"
                      :group-select="false"
                      :max-height="100"
                      :limit="3"
                      placeholder="Select one"
                      :searchable="true"
                      track-by="id"
                      disabled
                      :custom-label="customLabelBatch"
                      @select="selectBatch(tr, tr.item_id, ts)"
                    />
                  </div>
                  <div class="w-full flex flex-row justify-end gap-10">
                    <span class="w-1/8">Qty:</span>
                    <vs-input
                      class="w-full"
                      v-model="ts.quantity"
                      disabled
                      type="number"
                      :min="0"
                      @input="rejectedCheck(tr, tr.item_id, ts)"
                    />
                  </div>

                  <div class="w-full flex flex-row justify-end gap-2">
                    <span>Reason:</span>

                    <multiselect
                      class="selectExample"
                      v-model="ts.reason"
                      :options="optionReason"
                      :multiple="false"
                      :allow-empty="true"
                      :group-select="false"
                      :max-height="100"
                      :limit="3"
                      placeholder="Select one"
                      :searchable="true"
                      track-by="id"
                      label="reason"
                      disabled
                      @select="rejectedCheckReason(tr, tr.item_id, ts)"
                    />
                  </div>
                  <br v-if="itemFree[indextr].rejected_reason.length > 1" />
                </div>
                <div class="vx-col w-1/4 flex flex-col justify-center">
                  <div class="vx-input-group flex">
                    <!-- <vs-button
                      v-if="
                        itemFree[indextr].rejected_reason.length > 1 &&
                        !disableRejectAndAccept
                      "
                      @click.stop="removeRowFreeReason(indextr, index)"
                      size="small"
                      color="danger"
                      icon-pack="feather"
                      icon="icon-trash"
                      style="margin-right: 5px"
                      title="Remove Row"
                    />

                    <vs-button
                      v-if="!disableRejectAndAccept"
                      @click.stop="addRowFreeReason(indextr)"
                      size="small"
                      color="success"
                      icon-pack="feather"
                      icon="icon-plus"
                      title="Add Row"
                    /> -->
                  </div>
                </div>
              </div>
            </vs-td>
            <vs-td>
              <div>
                <vs-input
                  class="w-full"
                  v-model="tr.notes"
                  disabled
                  type="text"
                />
              </div>
            </vs-td>
          </vs-tr>
          <tr
            v-for="index in addTr"
            :key="index"
            style="background: transparent"
          >
            <td></td>
          </tr>
        </template>
      </vs-table>
      <br />
      <br />
      <br />
      <br />
      <br />
      <!-- <vs-pagination
          style="padding-top: 5px"
          :total="table.totalPage"
          v-model="setPage"
        /> -->
    </div>
  </vx-card>
</template>

<script>
import moment from "moment";
import MapViewer from "@/components/MapViewer.vue";
import RouteMapViewer from "@/components/RouteMapViewer.vue";
export default {
  components: {
    MapViewer,
    RouteMapViewer,
  },

  async mounted() {
    this.handleCheckEditOrShow();
    let params = {
      length: 999,
      order: "id",
      sort: "asc",
      reason_groups_name: ["POD Failed", "POD Partial"],
    };

    //check if selectedStatus not selected then set disableRejectAndAccept and disabledReason to true

    await this.getReasons(params);
    await this.getData();
  },

  data() {
    return {
      prosessingSave: false,
      calculatePromotion: true,
      isAllowPartial: true,
      isDetailCombo: false,
      editOrShow: false,
      table: this.tableDefaultState(),
      warehouseID: null,

      dateNow: moment().format("YYYY-MM-DD"),
      selectedStatus: { name: "", ID: 0 },
      optionalStatus: [
        { name: "Complete", ID: 1 },
        { name: "Partial Complete ", ID: 2 },
        // { name: "Partial Redeliver ", ID: 3 },
        { name: "Failed Cancel", ID: 4 },
        { name: "Failed Redeliver", ID: 5 },
      ],
      disableRejectAndAccept: true,
      disabledReason: true,
      addTr: 3,
      optionReason: [],
      optionReasonMain: [],
      selectedReason: null,
      isDelivered: false,

      // E-POD Details Section
      showDetailVisit: false,

      // Photo URLs
      imgCOD: null,
      imgVisit: null,
      imgPOD: null,

      // Photo modal data
      showPhotoModal: false,
      selectedPhotoType: "",
      selectedPhotoUrl: "",
      photoDetails: {
        visit: {
          title: "🚚 Visit Photo",
          description: "Driver arrival documentation at delivery location",
          timestamp: "2024-08-08 08:30:00",
          location: "Universitas Brawijaya, Malang",
        },
        cod: {
          title: "💰 COD Photo",
          description: "Cash on delivery payment confirmation",
          timestamp: "2024-08-08 10:15:00",
          amount: "Rp 150,000",
        },
        pod: {
          title: "📦 POD Photo",
          description: "Proof of delivery completion with recipient signature",
          timestamp: "2024-08-08 10:30:00",
          recipient: "Budi Santoso",
        },
      },

      // Route map settings
      showRouteMap: true,

      // Route data
      routeData: {
        origin: {
          latitude: null,
          longitude: null,
          accuracy: null,
          location_timestamp: null,
          location_address: null,
        },
        destination: {
          latitude: null,
          longitude: null,
          accuracy: null,
          location_timestamp: null,
          location_address: null,
        },
      },

      // Data untuk customer location (dari master data)
      customerLocation: {
        latitude: null,
        longitude: null,
      },

      // Status untuk radius checking
      isOutsideRadius: null,

      // Sample location data
      sampleLocationData: {
        latitude: null,
        longitude: null,
        accuracy: null,
        location_timestamp: null,
        location_address: null,
      },

      itemLine: [],
      itemCombo: [],
      itemFree: [],
      ComboMaster: [],
      RejectedReason: [],
      detailCombo: [],
      FGItem: [],
      ItFG: [],
      podDateError: "",
    };
  },
  methods: {
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },

    // ============= E-POD Detail Methods Start =============

    // Method untuk toggle detail visit section
    handleDetailsEpod() {
      this.showDetailVisit = !this.showDetailVisit;
    },

    // Methods untuk photo modal
    openPhotoModal(type, url) {
      this.selectedPhotoType = type;
      this.selectedPhotoUrl = url;
      this.showPhotoModal = true;
    },

    closePhotoModal() {
      this.showPhotoModal = false;
      this.selectedPhotoType = "";
      this.selectedPhotoUrl = "";
    },

    // Method untuk membuka gambar di tab baru
    openImageInNewTab() {
      if (this.selectedPhotoUrl) {
        window.open(this.selectedPhotoUrl, "_blank");
      }
    },

    // Method untuk download gambar
    downloadImage() {
      if (this.selectedPhotoUrl) {
        const link = document.createElement("a");
        link.href = this.selectedPhotoUrl;
        const deliveryOrderCode =
          this.table.data.delivery_order_code || "unknown";
        const sanitizedDeliveryOrderCode = deliveryOrderCode.replace(/-/g, "_");
        console.log(
          "Sanitized Delivery Order Code:",
          sanitizedDeliveryOrderCode
        );

        link.download = `${this.selectedPhotoType}_${sanitizedDeliveryOrderCode}.jpg`;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$vs.notify({
          title: "Download Started",
          text: `${this.selectedPhotoType} photo download initiated`,
          color: "success",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-download",
        });
      }
    },

    // Method untuk handle keyboard events (ESC untuk close modal)
    handleKeyDown(event) {
      if (event.key === "Escape" && this.showPhotoModal) {
        this.closePhotoModal();
      }
    },

    // Method untuk format timestamp photo
    formatPhotoTime(timestamp) {
      if (!timestamp) return "Unknown time";
      return moment(timestamp).format("DD MMM YYYY, HH:mm");
    },

    // Method untuk clean dan validate koordinat GPS
    cleanCoordinate(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }

      const parsed = parseFloat(value);
      if (isNaN(parsed)) {
        return null;
      }

      return parsed;
    },

    // Helper function untuk menghitung jarak (Haversine formula)
    deg2rad(deg) {
      return deg * (Math.PI / 180);
    },

    // Calculate distance between two coordinates in kilometers
    calculateDistance(lat1, lon1, lat2, lon2) {
      const R = 6371; // Earth's radius in kilometers
      const dLat = this.deg2rad(lat2 - lat1);
      const dLon = this.deg2rad(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) *
          Math.cos(this.deg2rad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    },

    // ============= E-POD Detail Methods End =============

    /**
     * Check if a row in hu_rejected is a default row
     * Default row has: reason=null, batches=null, quantity=0, max_quantity=0
     */
    isDefaultRow(row) {
      return (
        row.reason === null &&
        row.batches === null &&
        row.quantity === 0 &&
        row.max_quantity === 0
      );
    },

    /**
     * Clean up default rows from hu_rejected array
     * If array has more than 1 item and contains default row, remove the default row
     * If array has only 1 item and it's default, keep it
     */
    cleanupDefaultRows(rejectedReasonItem) {
      if (!rejectedReasonItem || !rejectedReasonItem.hu_rejected) return;

      const huRejected = rejectedReasonItem.hu_rejected;

      // Only clean if there are more than 1 items
      if (huRejected.length > 1) {
        // Find and remove default rows
        rejectedReasonItem.hu_rejected = huRejected.filter(
          (row) => !this.isDefaultRow(row)
        );

        console.log(
          `Cleaned default rows for item ${rejectedReasonItem.item_code}. ` +
            `Before: ${huRejected.length}, After: ${rejectedReasonItem.hu_rejected.length}`
        );
      }
    },

    /**
     * Clean up all RejectedReason items
     */
    cleanupAllRejectedReasons() {
      if (!this.RejectedReason || this.RejectedReason.length === 0) return;

      this.RejectedReason.forEach((item) => {
        this.cleanupDefaultRows(item);
      });

      console.log("Finished cleaning all RejectedReason items");
    },

    /**
     * Update is_all_batch based on adjusted_quantity
     * @param {Object} item - Item object (itemLine, itemCombo, or itemFree)
     * Simple rule: if adjusted_quantity === 0, then is_all_batch = true (all rejected)
     *             if adjusted_quantity > 0, then is_all_batch = false (has accepted)
     */
    updateIsAllBatch(item) {
      if (item) {
        item.is_all_batch = item.adjusted_quantity === 0;
        console.log(
          ">>>>>updateIsAllBatch - Item:",
          item.item_code,
          "Adjusted:",
          item.adjusted_quantity,
          "is_all_batch:",
          item.is_all_batch
        );
      }
    },

    /**
     * Convert quantity to multiple unit levels
     * @param {number} quantity - The quantity in amount_uom (base unit)
     * @param {Array} itemUnits - Array of item units with level, amount_uom
     * @returns {Array} Array of converted units with quantity
     */
    convertQuantityToUnits(quantity, itemUnits) {
      if (!itemUnits || itemUnits.length === 0) return [];

      // Sort units by level in descending order (highest level first)
      const sortedUnits = [...itemUnits].sort((a, b) => b.level - a.level);

      let remainingQty = Number(quantity);
      const result = [];

      // Special case: if quantity is 0, return level 1 unit with 0 quantity
      if (remainingQty === 0) {
        const level1Unit = sortedUnits.find((unit) => unit.level === 1);
        if (level1Unit) {
          return [
            {
              unit_name: level1Unit.unit_name,
              unit_id: level1Unit.unit_id,
              quantity: 0,
              amount_uom: level1Unit.amount_uom,
              level: level1Unit.level,
            },
          ];
        }
        return [];
      }

      // Iterate through each unit level
      for (const unit of sortedUnits) {
        if (remainingQty <= 0) break;

        // Calculate how many of this unit can fit
        const unitQty = Math.floor(remainingQty / unit.amount_uom);

        if (unitQty > 0) {
          result.push({
            unit_name: unit.unit_name,
            unit_id: unit.unit_id,
            quantity: unitQty,
            amount_uom: unit.amount_uom,
            level: unit.level,
          });

          // Update remaining quantity
          remainingQty -= unitQty * unit.amount_uom;
        }
      }

      return result;
    },

    /**
     * Format note_accepted for display
     * @param {Array} convertedUnits - Array from convertQuantityToUnits
     * @returns {string} Formatted string like "1 KAR, 2 BOX, 1 PC"
     */
    formatAcceptedNote(convertedUnits) {
      if (!convertedUnits || convertedUnits.length === 0) return "";

      return convertedUnits
        .map((unit) => `${unit.quantity} ${unit.unit_name}`)
        .join(", ");
    },

    /**
     * Apply conversion to item line
     * @param {Object} item - Item line object
     */
    applyQuantityConversion(item) {
      if (!item.item_units) {
        item.note_accepted = [];
        item.note_accepted_display = "";
        return;
      }

      // Convert the adjusted quantity (even if 0)
      const converted = this.convertQuantityToUnits(
        item.adjusted_quantity || 0,
        item.item_units
      );

      // Store in note_accepted for display
      item.note_accepted = converted;

      // Format for display string
      item.note_accepted_display = this.formatAcceptedNote(converted);

      return converted;
    },

    async getData() {
      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/proof-of-delivery/editV2", {
          params: {
            id: this.$route.query.id,
          },
        })
        .then((resp) => {
          // console.log("rrrrrrr", resp);
          if (resp.code == 200) {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data;

            this.table.data.proof_of_delivery_date =
              this.table.data.proof_of_delivery_date != ""
                ? moment(this.table.data.proof_of_delivery_date).format(
                    "YYYY-MM-DD"
                  )
                : moment().format("YYYY-MM-DD");
            this.isDelivered = resp.data.is_delivered;

            this.optionalStatus.forEach((element) => {
              if (element.ID == this.table.data.status_delivery) {
                this.selectedStatus = element;
              }
            });
            //set is_document default value true
            if (this.table.data.is_document) {
              this.table.data.is_document = resp.data.is_document;
            } else {
              this.table.data.is_document = true;
            }

            // ============= Populate E-POD Detail Data Start =============

            // Populate photo URLs
            this.imgVisit = resp.data.photo_visit || null;
            this.imgCOD = resp.data.photo_cod || null;
            this.imgPOD = resp.data.photo_pod || null;

            // Populate GPS coordinates
            const customerLat = this.cleanCoordinate(
              resp.data.latitude_customer
            );
            const customerLng = this.cleanCoordinate(
              resp.data.longitude_customer
            );
            const warehouseLat = this.cleanCoordinate(
              resp.data.latitude_warehouse
            );
            const warehouseLng = this.cleanCoordinate(
              resp.data.longitude_warehouse
            );

            // Set customer location dari master data
            if (customerLat !== null && customerLng !== null) {
              this.customerLocation = {
                latitude: customerLat,
                longitude: customerLng,
              };
            }

            // Halaman ini untuk POD manual & driver yang tidak melakukan visit:
            // tidak ada GPS visit yang bisa diverifikasi, jadi selalu Out of Radius
            this.isOutsideRadius = true;

            // Set sample location data untuk map viewer tunggal (gunakan warehouse location)
            if (warehouseLat !== null && warehouseLng !== null) {
              this.sampleLocationData = {
                latitude: warehouseLat,
                longitude: warehouseLng,
                accuracy: resp.data.accuracy_warehouse || null,
                location_timestamp: resp.data.delivery_date || null,
                location_address: resp.data.warehouse_address || null,
              };

              console.log("✅ Warehouse GPS Location Valid:", {
                lat: warehouseLat,
                lng: warehouseLng,
              });
            } else {
              console.warn("⚠️ Invalid Warehouse GPS Location:", {
                latitude_warehouse: resp.data.latitude_warehouse,
                longitude_warehouse: resp.data.longitude_warehouse,
              });
            }

            // Set route data untuk route map viewer
            // Origin = Warehouse Location
            // Destination = Customer Location from Master Data
            // Gunakan variable warehouseLat dan warehouseLng yang sudah dideklarasikan di atas

            if (warehouseLat !== null && warehouseLng !== null) {
              this.routeData.origin = {
                latitude: warehouseLat,
                longitude: warehouseLng,
                accuracy: null,
                location_timestamp: resp.data.delivery_date || null,
                location_address: resp.data.warehouse_address || null,
              };

              console.log("✅ Warehouse GPS Location for Route Valid:", {
                lat: warehouseLat,
                lng: warehouseLng,
              });
            } else {
              console.warn("⚠️ Invalid Warehouse GPS Location for Route:", {
                latitude_warehouse: resp.data.latitude_warehouse,
                longitude_warehouse: resp.data.longitude_warehouse,
              });
            }

            if (customerLat !== null && customerLng !== null) {
              this.routeData.destination = {
                latitude: customerLat,
                longitude: customerLng,
                accuracy: null,
                location_timestamp: resp.data.proof_of_delivery_date || null,
                location_address: resp.data.customer_address || null,
              };

              console.log("✅ Customer GPS Location Valid:", {
                lat: customerLat,
                lng: customerLng,
              });
            } else {
              console.warn("⚠️ Invalid Customer GPS Location:", {
                latitude_customer: resp.data.latitude_customer,
                longitude_customer: resp.data.longitude_customer,
              });
            }

            console.log("📸 E-POD Photos populated:", {
              visit: this.imgVisit ? "✅ Available" : "❌ Not Available",
              cod: this.imgCOD ? "✅ Available" : "❌ Not Available",
              pod: this.imgPOD ? "✅ Available" : "❌ Not Available",
            });

            console.log("📍 E-POD Location Data populated:", {
              hasWarehouseLocation:
                warehouseLat !== null && warehouseLng !== null,
              hasCustomerLocation: customerLat !== null && customerLng !== null,
              hasRouteData:
                warehouseLat !== null &&
                warehouseLng !== null &&
                customerLat !== null &&
                customerLng !== null,
              warehouseLocation: this.routeData.origin,
              customerLocation: this.routeData.destination,
            });

            // ============= Populate E-POD Detail Data End =============

            for (let index = 0; index < resp.data.items_pod.length; index++) {
              // console.log("JJJJJJ", this.table.data.items_pod[index]);
              let linehead = this.table.data.items_pod[index];

              let dataAccept = null;
              if (this.table.data.status_delivery == 2) {
                dataAccept = this.table.data.items_pod[index].item_units.filter(
                  (unit) => unit.level == 1
                )[0];

                //change quantity to table.data.items_pod[index].adjusted_quantity
                dataAccept.quantity =
                  this.table.data.items_pod[index].adjusted_quantity;
              } else {
                dataAccept = this.table.data.items_pod[index].item_units.filter(
                  (unit) =>
                    unit.id == this.table.data.items_pod[index].item_unit_id
                )[0];
              }

              if (this.table.data.items_pod[index].rejected_reason != null) {
                let dataReject =
                  this.table.data.items_pod[index].rejected_reason;
                for (
                  let indexReject = 0;
                  indexReject < dataReject.length;
                  indexReject++
                ) {
                  // Ensure data is not duplicated in RejectedReason for the same item_id and item_unit
                  const existingReason = this.RejectedReason.find(
                    (reason) =>
                      reason.item_id ===
                        this.table.data.items_pod[index].item_id &&
                      reason.item_unit ===
                        this.table.data.items_pod[index].item_unit &&
                      reason.reason_id === dataReject[indexReject].reason.id &&
                      reason.is_reguler ===
                        this.table.data.items_pod[index].is_reguler &&
                      reason.is_free ===
                        this.table.data.items_pod[index].is_free &&
                      reason.is_combo ===
                        this.table.data.items_pod[index].is_combo &&
                      reason.combo_id ===
                        this.table.data.items_pod[index].combo_id &&
                      reason.allow_partial ===
                        this.table.data.items_pod[index].is_allow_partial
                  );
                  if (!existingReason) {
                    // Add new reason if not already present
                    let temp_hu = null;

                    let temp_batch = null;
                    temp_batch = this.table.data.items_pod[
                      index
                    ].data_dol.filter(
                      (batch) =>
                        batch.delivery_order_line_id ==
                        dataReject[indexReject].delivery_order_line_id
                    )[0];

                    temp_hu = this.table.data.items_pod[index].item_units
                      .sort((a, b) => b.level - a.level)
                      .find(
                        (hu) => hu.unit_id == dataReject[indexReject].unit_id
                      );

                    this.RejectedReason.push({
                      item_id: this.table.data.items_pod[index].item_id,
                      item_code: this.table.data.items_pod[index].item_code,
                      item_unit: this.table.data.items_pod[index].item_unit,
                      combo_id: this.table.data.items_pod[index].combo_id,
                      combo_quantity_general:
                        this.table.data.items_pod[index].combo_quantity_general,
                      combo_quantity:
                        this.table.data.items_pod[index].combo_quantity,
                      combo_code: this.table.data.items_pod[index].combo_code,
                      is_reguler: this.table.data.items_pod[index].is_reguler,
                      is_combo: this.table.data.items_pod[index].is_combo,
                      is_free: this.table.data.items_pod[index].is_free,
                      list_batch: this.table.data.items_pod[index].data_dol,
                      item_units: this.table.data.items_pod[index].item_units,
                      max_reason_added:
                        this.table.data.items_pod[index].data_dol.length,
                      hu_rejected: [
                        {
                          hu: temp_hu,
                          reason: dataReject[indexReject].reason,
                          batches: temp_batch,
                          list_batch: this.table.data.items_pod[index].data_dol,
                          quantity: dataReject[indexReject].quantity,
                          max_quantity:
                            temp_batch.amount_uom_total / temp_hu.amount_uom,
                        },
                      ],
                      allow_partial:
                        this.table.data.items_pod[index].is_allow_partial,
                    });
                  } else {
                    // If the reason already exists, just update the hu_rejected array
                    const huRejected = existingReason.hu_rejected.find(
                      (hu) =>
                        hu.hu.unit_id == dataReject[indexReject].unit_id &&
                        hu.batches.delivery_order_line_id ==
                          dataReject[indexReject].delivery_order_line_id
                    );
                    if (!huRejected) {
                      let temp_hu = null;
                      let temp_batch = null;
                      temp_batch = this.table.data.items_pod[
                        index
                      ].data_dol.filter(
                        (batch) =>
                          batch.delivery_order_line_id ==
                          dataReject[indexReject].delivery_order_line_id
                      )[0];
                      temp_hu = this.table.data.items_pod[index].item_units
                        .sort((a, b) => b.level - a.level)
                        .find(
                          (hu) => hu.unit_id == dataReject[indexReject].unit_id
                        );

                      existingReason.hu_rejected.push({
                        hu: temp_hu,
                        reason: dataReject[indexReject].reason,
                        batches: temp_batch,
                        list_batch: this.table.data.items_pod[index].data_dol,
                        quantity: dataReject[indexReject].quantity,
                        max_quantity:
                          temp_batch.amount_uom_total / temp_hu.amount_uom,
                      });
                    } else {
                      // If the hu already exists, just update the quantity and reason
                      huRejected.quantity += dataReject[indexReject].quantity;
                      huRejected.reason = dataReject[indexReject].reason;
                    }
                  }
                }

                //append to RejectedReason if exist then push to hu_rejected
              } else {
                this.RejectedReason.push({
                  item_id: this.table.data.items_pod[index].item_id,
                  item_code: this.table.data.items_pod[index].item_code,
                  item_unit: this.table.data.items_pod[index].item_unit,
                  combo_id: this.table.data.items_pod[index].combo_id,
                  combo_quantity_general:
                    this.table.data.items_pod[index].combo_quantity_general,
                  combo_quantity:
                    this.table.data.items_pod[index].combo_quantity,
                  combo_code: this.table.data.items_pod[index].combo_code,
                  is_reguler: this.table.data.items_pod[index].is_reguler,
                  is_combo: this.table.data.items_pod[index].is_combo,
                  is_free: this.table.data.items_pod[index].is_free,
                  list_batch: this.table.data.items_pod[index].data_dol,
                  item_units: this.table.data.items_pod[index].item_units,
                  max_reason_added:
                    this.table.data.items_pod[index].data_dol.length,
                  hu_rejected: [
                    {
                      hu: dataAccept,
                      reason: null,
                      batches: null,
                      list_batch: [],
                      quantity: 0,
                      max_quantity: 0,
                    },
                  ],
                  allow_partial:
                    this.table.data.items_pod[index].is_allow_partial,
                });
              }

              let dataSV = this.RejectedReason.filter(
                (items) =>
                  items.item_id == linehead.item_id &&
                  items.item_unit == linehead.item_unit &&
                  items.is_reguler == linehead.is_reguler &&
                  items.is_free == linehead.is_free &&
                  items.is_combo == linehead.is_combo &&
                  items.allow_partial == linehead.is_allow_partial
              );

              //check if foundData.length > 1 then remove the rest
              // if (dataSV.length > 1) {
              //   dataSV.forEach((item, index) => {
              //     if (index > 0) {
              //       console.log("ini itemnyaaaaaa", item);
              //       //append to RejectedReason index 0
              //       // item.hu_rejected.forEach((hu) => {
              //       //   dataSV[0].hu_rejected.push(hu);
              //       // });
              //       //remove item from RejectedReason
              //       this.RejectedReason.splice(
              //         this.RejectedReason.indexOf(item),
              //         1
              //       );
              //     }
              //   });
              // }
              //check if data is_reguler then append to itemLine if not then append to itemCombo or itemFree
              if (resp.data.items_pod[index].is_reguler) {
                var batchExist = [];
                //check if delivery_order_line_id exist in this.RejectedReason then append delivery_order_line_id to batchExist
                this.RejectedReason.forEach((element) => {
                  batchExist.push(element.delivery_order_line_id);
                });

                // Find amount_uom from item_units (level 1)
                const level1UnitReg = resp.data.items_pod[
                  index
                ].item_units.find((unit) => unit.level === 1);
                const amountUomReg = level1UnitReg
                  ? level1UnitReg.amount_uom
                  : resp.data.items_pod[index].amount_uom || 1;

                this.itemLine.push({
                  id: resp.data.items_pod[index].id,
                  delivery_order_line_id:
                    resp.data.items_pod[index].delivery_order_line_id,
                  item_code: resp.data.items_pod[index].item_code,
                  item_name: resp.data.items_pod[index].item_name,
                  item_unit: resp.data.items_pod[index].item_unit,
                  item_id: resp.data.items_pod[index].item_id,
                  quantity: resp.data.items_pod[index].quantity,
                  amount_uom: resp.data.items_pod[index].amount_uom,
                  reason_id: resp.data.items_pod[index].reason_id,
                  notes: resp.data.items_pod[index].notes,
                  batches: resp.data.items_pod[index].data_dol,
                  is_combo: resp.data.items_pod[index].is_combo,
                  is_reguler: resp.data.items_pod[index].is_reguler,
                  is_free: resp.data.items_pod[index].is_free,
                  combo_id: resp.data.items_pod[index].combo_id,
                  combo_code: resp.data.items_pod[index].combo_code,
                  combo_quantity: resp.data.items_pod[index].combo_quantity,
                  combo_quantity_general:
                    resp.data.items_pod[index].combo_quantity_general,
                  item_units: resp.data.items_pod[index].item_units,
                  qty_after_conv:
                    resp.data.items_pod[index].quantity * amountUomReg,
                  //if adjust qty is null or 0, use qty_after_conv only if status_delivery is 0 (new POD)
                  adjusted_quantity:
                    resp.data.items_pod[index].adjusted_quantity !== null &&
                    resp.data.items_pod[index].adjusted_quantity !== undefined
                      ? resp.data.items_pod[index].adjusted_quantity
                      : resp.data.status_delivery == 0
                      ? resp.data.items_pod[index].quantity * amountUomReg
                      : 0,

                  accepted_item: dataAccept,
                  note_accepted: [],
                  note_real_qty: "",

                  return_quantity: resp.data.items_pod[index].return_quantity
                    ? resp.data.items_pod[index].return_quantity
                    : resp.data.items_pod[index].quantity * amountUomReg,
                  rejected_reason: this.RejectedReason,
                  // is_all_batch: isAllBatch,
                  allow_partial: resp.data.items_pod[index].is_allow_partial,
                });
              } else if (resp.data.items_pod[index].is_combo) {
                // Find amount_uom from item_units (level 1)
                const level1UnitCombo = resp.data.items_pod[
                  index
                ].item_units.find((unit) => unit.level === 1);
                const amountUomCombo = level1UnitCombo
                  ? level1UnitCombo.amount_uom
                  : resp.data.items_pod[index].amount_uom || 1;

                this.itemCombo.push({
                  id: resp.data.items_pod[index].id,
                  delivery_order_line_id:
                    resp.data.items_pod[index].delivery_order_line_id,
                  item_code: resp.data.items_pod[index].item_code,
                  item_name: resp.data.items_pod[index].item_name,
                  item_unit: resp.data.items_pod[index].item_unit,
                  item_id: resp.data.items_pod[index].item_id,
                  quantity: resp.data.items_pod[index].quantity,
                  reason_id: resp.data.items_pod[index].reason_id,
                  notes: resp.data.items_pod[index].notes,
                  batches: resp.data.items_pod[index].data_dol,
                  is_combo: resp.data.items_pod[index].is_combo,
                  is_reguler: resp.data.items_pod[index].is_reguler,
                  is_free: resp.data.items_pod[index].is_free,
                  combo_id: resp.data.items_pod[index].combo_id,
                  combo_code: resp.data.items_pod[index].combo_code,
                  combo_quantity: resp.data.items_pod[index].combo_quantity,
                  combo_quantity_general:
                    resp.data.items_pod[index].combo_quantity_general,
                  item_units: resp.data.items_pod[index].item_units,
                  qty_after_conv:
                    resp.data.items_pod[index].quantity * amountUomCombo,
                  //if adjust qty is null or 0, use qty_after_conv only if status_delivery is 0 (new POD)
                  adjusted_quantity:
                    resp.data.items_pod[index].adjusted_quantity !== null &&
                    resp.data.items_pod[index].adjusted_quantity !== undefined
                      ? resp.data.items_pod[index].adjusted_quantity
                      : resp.data.status_delivery == 0
                      ? resp.data.items_pod[index].quantity * amountUomCombo
                      : 0,

                  accepted_item: dataAccept,
                  note_accepted: [],
                  note_real_qty: "",

                  return_quantity: resp.data.items_pod[index].return_quantity
                    ? resp.data.items_pod[index].return_quantity
                    : resp.data.items_pod[index].quantity * amountUomCombo,
                  rejected_reason: this.RejectedReason,
                  allow_partial: resp.data.items_pod[index].is_allow_partial,
                });
              } else {
                // Find amount_uom from item_units (level 1)
                const level1UnitFree = resp.data.items_pod[
                  index
                ].item_units.find((unit) => unit.level === 1);
                const amountUomFree = level1UnitFree
                  ? level1UnitFree.amount_uom
                  : 1;

                this.itemFree.push({
                  id: resp.data.items_pod[index].id,
                  delivery_order_line_id:
                    resp.data.items_pod[index].delivery_order_line_id,
                  item_code: resp.data.items_pod[index].item_code,
                  item_name: resp.data.items_pod[index].item_name,
                  item_unit: resp.data.items_pod[index].item_unit,
                  item_id: resp.data.items_pod[index].item_id,
                  quantity: resp.data.items_pod[index].quantity,
                  reason_id: resp.data.items_pod[index].reason_id,
                  notes: resp.data.items_pod[index].notes,
                  batches: resp.data.items_pod[index].data_dol,
                  is_combo: resp.data.items_pod[index].is_combo,
                  is_reguler: resp.data.items_pod[index].is_reguler,
                  is_free: resp.data.items_pod[index].is_free,
                  combo_id: resp.data.items_pod[index].combo_id,
                  combo_code: resp.data.items_pod[index].combo_code,
                  combo_quantity: resp.data.items_pod[index].combo_quantity,
                  combo_quantity_general:
                    resp.data.items_pod[index].combo_quantity_general,
                  item_units: resp.data.items_pod[index].item_units,
                  qty_after_conv:
                    resp.data.items_pod[index].quantity * amountUomFree,
                  //if adjust qty is null or 0, use quantity only if status_delivery is 0 (new POD)
                  adjusted_quantity:
                    resp.data.items_pod[index].adjusted_quantity !== null &&
                    resp.data.items_pod[index].adjusted_quantity !== undefined
                      ? resp.data.items_pod[index].adjusted_quantity
                      : resp.data.status_delivery == 0
                      ? resp.data.items_pod[index].quantity
                      : 0,

                  accepted_item: dataAccept,
                  note_accepted: [],
                  note_real_qty: "",

                  return_quantity: resp.data.items_pod[index].adjusted_quantity
                    ? resp.data.items_pod[index].return_quantity
                    : resp.data.items_pod[index].quantity * amountUomFree,
                  rejected_reason: this.RejectedReason,
                  // is_all_batch: isAllBatch,
                  allow_partial: resp.data.items_pod[index].is_allow_partial,
                });
              }

              //sorted itemLine by sku_name then sku_code
              this.itemLine.sort((a, b) => {
                if (a.item_name < b.item_name) {
                  return -1;
                }
                if (a.item_name > b.item_name) {
                  return 1;
                }
                return 0;
              });

              //check if status is failed_cancel then set rejected_reason quantity = quantity * amount_uom
              if (this.selectedStatus.ID == 4 || this.selectedStatus.ID == 5) {
                this.optionReason = this.optionReasonMain.filter(
                  (reason) => reason.reason_group == "POD Failed"
                );
                // console.log(">>>>>Reason", this.optionReason);

                //get data selectedReason from itemLine rejected_reason index 0
                this.selectedReason = this.optionReasonMain.filter(
                  (reason) => reason.id == resp.data.reason_id
                )[0];
              } else {
                this.optionReason = this.optionReasonMain.filter(
                  (reason) => reason.reason_group == "POD Partial"
                );
              }
            }

            // console.log("ini itemLine", this.itemLine);

            if (this.itemCombo.length > 0) {
              for (let i = 0; i < this.itemCombo.length; i++) {
                //append data to ComboMaster then remove duplicate
                let comboss = this.RejectedReason.filter(
                  (reason) => reason.combo_id == this.itemCombo[i].combo_id
                );

                console.log(">>>>>comboss", comboss);
                console.log(
                  ">>>>>this.itemCombo[i].combo_id",
                  this.itemCombo[i]
                );

                comboss.forEach((element) => {
                  var itemRejected = 0;
                  var itemAccepeted = 0;
                  if (
                    this.itemCombo[i].return_quantity != 0 &&
                    this.selectedStatus.ID != 0
                  ) {
                    itemRejected =
                      this.itemCombo[i].adjusted_quantity /
                      element.combo_quantity_general;
                    itemRejected = element.combo_quantity - itemRejected;
                    itemAccepeted = element.combo_quantity - itemRejected;
                  } else {
                    itemRejected = 0;
                    itemAccepeted = element.combo_quantity;
                  }
                  this.ComboMaster.push({
                    combo_id: element.combo_id,
                    combo_code: element.combo_code,
                    combo_quantity: element.combo_quantity,
                    combo_quantity_general: element.combo_quantity_general,
                    combo_quantity_accepted: itemAccepeted,
                    combo_quantity_rejected: itemRejected,
                    combo_quantity_real: element.combo_quantity,
                    reason: element.hu_rejected
                      ? element.hu_rejected[0].reason
                      : null,
                  });
                });

                this.ComboMaster = this.ComboMaster.filter(
                  (v, i, a) =>
                    a.findIndex((t) => t.combo_id === v.combo_id) === i
                );
              }
            }

            console.log(">>>>>ComboMaster", this.ComboMaster);
            console.log(">>>>>itemCombo", this.itemCombo);
            console.log(">>>>>itemLine", this.itemLine);

            // Check and set is_all_batch based on adjusted_quantity AFTER all items are created
            // Simple logic: if adjusted_quantity === 0, then is_all_batch = true (all rejected)
            //              if adjusted_quantity > 0, then is_all_batch = false (partial/full accepted)
            this.itemLine.forEach((item) => {
              console.log(
                ">>>>>Check is_all_batch - Item:",
                item.item_code,
                "Adjusted Qty:",
                item.adjusted_quantity,
                "Qty After Conv:",
                item.qty_after_conv
              );

              // Simple check: adjusted_quantity === 0 means all rejected
              if (item.adjusted_quantity === 0) {
                item.is_all_batch = true;
              } else {
                item.is_all_batch = false;
              }
            });

            // Check and set is_all_batch for itemFree
            this.itemFree.forEach((item) => {
              console.log(
                ">>>>>Check is_all_batch - ItemFree:",
                item.item_code,
                "Adjusted Qty:",
                item.adjusted_quantity
              );

              // Simple check: adjusted_quantity === 0 means all rejected
              if (item.adjusted_quantity === 0) {
                item.is_all_batch = true;
              } else {
                item.is_all_batch = false;
              }
            });

            console.log(
              ">>>>>After is_all_batch check - itemLine:",
              this.itemLine
            );

            // Apply initial conversions - if status_delivery is 0, force adjusted_quantity to 0
            const forceZero = this.table.data.status_delivery == 0;

            this.itemLine.forEach((item) => {
              if (item.item_units) {
                if (forceZero) {
                  item.adjusted_quantity = 0;
                }
                this.applyQuantityConversion(item);
              }
            });
            this.itemCombo.forEach((item) => {
              if (item.item_units) {
                if (forceZero) {
                  item.adjusted_quantity = 0;
                }
                this.applyQuantityConversion(item);
              }
            });
            this.itemFree.forEach((item) => {
              if (item.item_units) {
                if (forceZero) {
                  item.adjusted_quantity = 0;
                }
                this.applyQuantityConversion(item);
              }
            });

            // console.log("weee", this.table.data);
            if (!this.isDelivered && this.table.data.notes == "ePOD") {
              this.handleCheckIfDelivered();
              this.$vs.notify({
                title: "Error",
                text: "This POD is not delivered yet",
                color: "warning",
                position: "top-right",
                iconPack: "feather",
                icon: "icon-alert-circle",
              });
            }

            // if (this.selectedReason != null && this.selectedStatus.ID != 2) {
            //   this.handleSelectReason();
            // }
            if (this.selectedStatus.ID == 0) {
              this.disableRejectAndAccept = true;
              this.disabledReason = true;
            }

            console.log("ini RejectedReason", this.RejectedReason);
            if (this.selectedStatus.ID != 0 && this.selectedStatus.ID != 2) {
              this.handleSelectStatus();
            }

            if (
              this.table.data.items_pod.some(
                (item) => item.is_allow_partial == true
              )
            ) {
              this.isAllowPartial = true;
            } else {
              this.isAllowPartial = false;
            }

            //check on this.RejectedReason if have duplicate item_id and item_unit and is_reguler, is_free, is_combo, combo_id, allow_partial then append hu_rejected to first item and remove the rest
            let uniqueReasons = [];
            this.RejectedReason.forEach((reason) => {
              const exists = uniqueReasons.find(
                (unique) =>
                  unique.item_id === reason.item_id &&
                  unique.item_unit === reason.item_unit &&
                  unique.is_reguler === reason.is_reguler &&
                  unique.is_free === reason.is_free &&
                  unique.is_combo === reason.is_combo &&
                  unique.combo_id === reason.combo_id &&
                  unique.allow_partial === reason.allow_partial
              );
              if (!exists) {
                uniqueReasons.push(reason);
              } else {
                // Append hu_rejected to the existing reason
                exists.hu_rejected = exists.hu_rejected.concat(
                  reason.hu_rejected
                );
              }
            });
            this.RejectedReason = uniqueReasons;

            // Clean up default rows from all RejectedReason items
            this.cleanupAllRejectedReasons();

            console.log(
              "ini RejectedReason after cleanup",
              this.RejectedReason
            );

            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    SubmitForm(value) {
      console.log(">>>>>ini value", value);

      var isProcess = value;
      this.prosessingSave = true;

      // Validate POD date before submission
      if (!this.validatePodDate()) {
        this.prosessingSave = false;
        this.$vs.notify({
          title: "Error",
          text: this.podDateError || "Invalid POD Date",
          color: "warning",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: `Confirm`,
            text: "Are you sure to Save this data?",
            accept: () => {
              this.submit(isProcess);
            },
            cancel: () => {
              this.prosessingSave = false;
            },
          });
        } else {
          this.prosessingSave = false;

          this.$vs.notify({
            title: "Error",
            text: "Please complete the form",
            color: "warning",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
        }
      });
      if (!this.calculatePromotion) {
        this.$vs.notify({
          title: "Error",
          text: "Please calculate promotion first",
          color: "warning",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        this.prosessingSave = false;
        return;
      }
    },

    submit(value) {
      console.log(">>>>>ini value", value);
      let itemData = [];
      //append itemLine, itemCombo, itemFree to itemData
      itemData = itemData.concat(this.itemLine, this.itemCombo, this.itemFree);
      if (!this.selectedStatus.ID) {
        this.prosessingSave = false;

        this.$vs.notify({
          title: "Error",
          text: "Please select status",
          color: "warning",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return;
      }

      if ([2, 4, 5].includes(this.selectedStatus.ID)) {
        let isReasonSelected = this.RejectedReason.some((item) =>
          item.hu_rejected.some((reason) => {
            if (reason.reason) {
              item.reason_id = reason.reason.id;
              return true;
            }
            return false;
          })
        );

        let allBatchesSelected = true;
        if (this.selectedStatus.ID === 2) {
          // validasi jika batches tidak dipilih pada status Partial Complete

          for (let i = 0; i < this.RejectedReason.length; i++) {
            const reasonItem = this.RejectedReason[i];
            for (let j = 0; j < reasonItem.hu_rejected.length; j++) {
              const huItem = reasonItem.hu_rejected[j];
              if (
                huItem.quantity > 0 &&
                (huItem.batches === null || huItem.batches === undefined)
              ) {
                allBatchesSelected = false;
                break;
              }
            }
            if (!allBatchesSelected) break;
          }

          if (!allBatchesSelected) {
            this.prosessingSave = false;

            this.$vs.notify({
              title: "Error",
              text: "Please select batches for all rejected quantities",
              color: "warning",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-circle",
            });
            return;
          }
          //validasi jika ada reason atau batch maka quantity pada rejected reason >= 0 dan tidak boleh melebihi max_quantity
          console.log(">>>>>this.RejectedReason", this.RejectedReason);
          for (let i = 0; i < this.RejectedReason.length; i++) {
            const reasonItem = this.RejectedReason[i];
            for (let j = 0; j < reasonItem.hu_rejected.length; j++) {
              const huItem = reasonItem.hu_rejected[j];

              if (
                huItem.quantity < 0 ||
                huItem.quantity > huItem.max_quantity
              ) {
                this.prosessingSave = false;

                this.$vs.notify({
                  title: "Error",
                  text: `Rejected quantity for item ${reasonItem.item_code} - ${reasonItem.item_unit} must be between 0 and ${huItem.max_quantity}`,
                  color: "warning",
                  position: "top-right",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                });
                return;
              }
            }
          }

          const allAdjustedQtyZero = itemData.every(
            (item) => item.adjusted_quantity === 0
          );

          // Convert rejected_reason quantities to numbers and set item_unit_id
          this.RejectedReason.forEach((item) =>
            item.hu_rejected.forEach((reason) => {
              reason.quantity = Number(reason.quantity);
            })
          );

          if (allAdjustedQtyZero) {
            this.prosessingSave = false;

            this.$vs.notify({
              title: "Error",
              text: "This POD should be set status to Failed Cancel",
              color: "warning",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-circle",
            });
            return;
          }

          const allAdjustedQtyEqual = itemData.every(
            (item) => item.adjusted_quantity === item.qty_after_conv
          );

          if (allAdjustedQtyEqual) {
            this.prosessingSave = false;

            this.$vs.notify({
              title: "Error",
              text: "This POD should be set status to Complete",
              color: "warning",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-circle",
            });
            return;
          }
        }

        if (!isReasonSelected) {
          this.prosessingSave = false;

          this.$vs.notify({
            title: "Error",
            text: "Please select reason",
            color: "warning",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
          return;
        }
      }
      let detailItems = [];
      //append data group by delivery_order_line_id to detailItems from RejectedReason

      this.itemLine.forEach((element) => {
        console.log("ini element", element);
        let itemUnit = null;
        itemUnit = element.item_units.filter((unit) => unit.level == 1)[0];
        element.batches.forEach((element2) => {
          detailItems.push({
            delivery_order_line_id: element2.delivery_order_line_id,
            item_id: element.item_id,
            reasons: null,
            rejected_qty: 0,
            adjusted_qty: element2.amount_uom_total,
            quantity: element2.amount_uom_total,
            batch: element2.batches,
            item_unit_id: itemUnit.id,
            item_code: element.item_code,
            item_unit: itemUnit.unit_name,
            combo_id: element.combo_id,
            free_item: element.is_free,
            notes: element.notes,
            rejected_reason: [],
          });
        });
      });

      this.itemCombo.forEach((element) => {
        console.log("ini elementcombo", element);
        let itemUnit = null;
        itemUnit = element.item_units.filter((unit) => unit.level == 1)[0];
        element.batches.forEach((element2) => {
          detailItems.push({
            delivery_order_line_id: element2.delivery_order_line_id,
            item_id: element.item_id,
            reasons: null,
            rejected_qty: 0,
            adjusted_qty: element2.amount_uom_total,
            quantity: element2.amount_uom_total,
            batch: element2.batches,
            item_unit_id: itemUnit.id,
            item_code: element.item_code,
            item_unit: itemUnit.unit_name,
            combo_id: element.combo_id,
            free_item: element.is_free,
            notes: element.notes,
            rejected_reason: [],
          });
        });
      });

      this.itemFree.forEach((element) => {
        console.log("ini elementfree", element);
        let itemUnit = null;
        itemUnit = element.item_units.filter((unit) => unit.level == 1)[0];
        element.batches.forEach((element2) => {
          detailItems.push({
            delivery_order_line_id: element2.delivery_order_line_id,
            item_id: element.item_id,
            reasons: null,
            rejected_qty: 0,
            adjusted_qty: element2.amount_uom_total,
            quantity: element2.amount_uom_total,
            batch: element2.batches,
            item_unit_id: itemUnit.id,
            item_code: element.item_code,
            item_unit: itemUnit.unit_name,
            combo_id: element.combo_id,
            free_item: element.is_free,
            notes: element.notes,
            rejected_reason: [],
          });
        });
      });

      console.log("ini detailItems", detailItems);

      this.RejectedReason.forEach((element) => {
        element.hu_rejected.forEach((element2) => {
          if (element2.batches != null) {
            // Find the existing item
            const existingItem = detailItems.find(
              (item) =>
                item.delivery_order_line_id ===
                element2.batches.delivery_order_line_id
            );

            if (existingItem) {
              if (this.selectedStatus.ID == 2) {
                // Calculate rejected quantity for partial complete
                const qtyRjct =
                  Number(element2.quantity) * Number(element2.hu.amount_uom);

                // Add to rejected reason details
                existingItem.rejected_reason.push({
                  item_unit_id: element2.hu.id,
                  item_unit: element2.hu.unit_name,
                  reason_name:
                    element2.reason != null ? element2.reason.reason : "",
                  reason_id: element2.reason != null ? element2.reason.id : 0,
                  reason_code:
                    element2.reason != null ? element2.reason.code : "",
                  quantity: Number(element2.quantity),
                });

                // Update rejected quantity (accumulate)
                existingItem.rejected_qty += qtyRjct;
              } else {
                // For other statuses (4, 5), set full rejection
                existingItem.rejected_qty = element2.batches.amount_uom_total;
              }

              // Set reason
              existingItem.reasons = element2.reason;
            }
          }
        });
      });

      // Calculate adjusted_qty after all rejections are processed
      detailItems.forEach((item) => {
        // Ensure adjusted_qty is calculated correctly based on total quantity minus rejected quantity
        item.adjusted_qty = Math.max(item.quantity - item.rejected_qty, 0);
        console.log("ini item adjusted", item);
        // Validation: adjusted_qty should never exceed original quantity
        if (item.adjusted_qty > item.quantity) {
          item.adjusted_qty = item.quantity;
        }
      });

      console.log("ini detailItems final", detailItems);

      //check on detailItems if adjusted_qty < 0 or rejected_qty < 0 then return error
      for (let index = 0; index < detailItems.length; index++) {
        if (detailItems[index].adjusted_qty < 0) {
          this.prosessingSave = false;

          this.$vs.notify({
            title: "Error",
            text:
              "Adjusted quantity cannot be less than 0 on item " +
              detailItems[index].item_code +
              " - " +
              detailItems[index].item_unit,
            color: "warning",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
          return;
        }
        if (detailItems[index].rejected_qty < 0) {
          this.prosessingSave = false;

          this.$vs.notify({
            title: "Error",
            text:
              "Rejected quantity cannot be less than 0 on item " +
              detailItems[index].item_code +
              " - " +
              detailItems[index].item_unit,
            color: "warning",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
          return;
        }
        //check if adjusted_qty + rejected_qty > quantity then return error
        if (
          detailItems[index].adjusted_qty + detailItems[index].rejected_qty >
          detailItems[index].quantity
        ) {
          this.prosessingSave = false;

          this.$vs.notify({
            title: "Error",
            text:
              "The sum of Adjusted quantity and Rejected quantity cannot be greater than Quantity on item " +
              detailItems[index].item_code +
              " - " +
              detailItems[index].item_unit,
            color: "warning",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
          return;
        }
      }

      // Prepare data for submission
      const submitItem = {
        id: this.table.data.id,
        delivery_order_id: this.table.data.delivery_order_id,
        delivery_order_code: this.table.data.delivery_order_code,
        transport_plan_id: this.table.data.transport_plan_id,
        transport_plan_code: this.table.data.shipment_number,
        proof_of_delivery_date: this.table.data.proof_of_delivery_date,
        sales_order_code: this.table.data.sales_order_code,
        status_delivery: this.selectedStatus.ID,
        is_document: this.table.data.is_document,
        reason_id: this.selectedReason ? this.selectedReason.id : 0,
        items_pod: detailItems,
      };

      // Send data to the server
      this.$vs.loading();
      this.$http
        .post("/api/wms/v1/proof-of-delivery/save-V2", {
          proof_of_delivery: submitItem,
          is_proccessed: value,
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            this.$vs.notify({
              title: "Success",
              text: "Proof of Delivery has been saved",
              color: "success",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
            this.handleClose();
          } else {
            this.$vs.notify({
              title: "Error",
              text: resp.message,
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
            this.prosessingSave = false;
          }
        });
    },
    async getReasons(params) {
      this.$http
        .get("/api/wms/v1/master/reason", {
          params: params,
        })
        .then((resp) => {
          if (resp.code == 200) {
            if (resp.data.records) {
              this.optionReasonMain = resp.data.records;
              if (this.optionReasonMain.length > 0) {
              } else {
                this.optionReasonMain = [];
                this.selectedReason = { reason: "" };
              }
            } else {
              this.optionReasonMain = [];
              this.selectedReason = {};
            }
          } else {
            // this.$vs.loading.close();
          }
        });
    },

    validatePodDate() {
      this.podDateError = "";

      if (!this.table.data.proof_of_delivery_date) {
        this.podDateError = "POD Date is required";
        return false;
      }

      const podDate = moment(this.table.data.proof_of_delivery_date);
      const today = moment(this.dateNow);
      const deliveryDate = moment(this.table.data.delivery_date);

      // Check if date is valid
      if (!podDate.isValid()) {
        this.podDateError = "Invalid date format";
        return false;
      }

      // Check if POD date is after today
      if (podDate.isAfter(today, "day")) {
        this.podDateError = "POD Date cannot be in the future";
        return false;
      }

      // Check if POD date is before delivery date
      if (
        this.table.data.delivery_date &&
        podDate.isBefore(deliveryDate, "day")
      ) {
        this.podDateError = "POD Date cannot be before Delivery Date";
        return false;
      }

      return true;
    },
    customLabelReason({ reason }) {
      return `${reason} `;
    },
    customLabelStatus({ name }) {
      return `${name} `;
    },
    handleClose() {
      // back to list
      this.$vs.loading();
      this.$router.push({ name: "proof-of-delivery" });
      this.$vs.loading.close();
    },
    handleSelectStatus() {
      if (this.selectedStatus.ID == 5 || this.selectedStatus.ID == 4) {
        this.calculatePromotion = true;

        this.disableRejectAndAccept = true;
        this.RejectedReason = [];
        //fill RejectedReason with all value this.itemLine.batches
        this.itemLine.forEach((line) => {
          line.batches.forEach((batch) => {
            const compatibleUnits = line.item_units.filter(
              (unit) => batch.amount_uom_total % unit.amount_uom === 0
            );
            if (compatibleUnits.length > 0) {
              const quantity =
                batch.amount_uom_total / compatibleUnits[0].amount_uom;
              this.RejectedReason.push({
                item_id: line.item_id,
                item_unit: line.item_unit,
                combo_id: line.combo_id,
                is_reguler: line.is_reguler,
                is_combo: line.is_combo,
                is_free: line.is_free,
                list_batch: line.batches,
                hu_rejected: [
                  {
                    hu: compatibleUnits,
                    reason: this.selectedReason,
                    batches: batch,
                    list_batch: [],
                    quantity: quantity,
                    max_quantity: quantity,
                  },
                ],
                allow_partial: line.allow_partial,
              });
            }
          });
          line.adjusted_quantity = 0;
          line.is_all_batch = true;
        });

        this.itemCombo.forEach((line) => {
          line.batches.forEach((batch) => {
            const compatibleUnits = line.item_units.filter(
              (unit) => batch.amount_uom_total % unit.amount_uom === 0
            );
            if (compatibleUnits.length > 0) {
              const quantity =
                batch.amount_uom_total / compatibleUnits[0].amount_uom;
              this.RejectedReason.push({
                item_id: line.item_id,
                item_unit: line.item_unit,
                combo_id: line.combo_id,
                is_reguler: line.is_reguler,
                is_combo: line.is_combo,
                is_free: line.is_free,
                list_batch: line.batches,
                hu_rejected: [
                  {
                    hu: compatibleUnits,
                    reason: this.selectedReason,
                    batches: batch,
                    list_batch: [],
                    quantity: quantity,
                    max_quantity: quantity,
                  },
                ],
              });
            }
          });
          line.adjusted_quantity = 0;
        });
        this.itemFree.forEach((line) => {
          line.batches.forEach((batch) => {
            const compatibleUnits = line.item_units.filter(
              (unit) => batch.amount_uom_total % unit.amount_uom === 0
            );
            if (compatibleUnits.length > 0) {
              const quantity =
                batch.amount_uom_total / compatibleUnits[0].amount_uom;
              this.RejectedReason.push({
                item_id: line.item_id,
                item_unit: line.item_unit,
                combo_id: line.combo_id,
                is_reguler: line.is_reguler,
                is_combo: line.is_combo,
                is_free: line.is_free,
                list_batch: line.batches,
                hu_rejected: [
                  {
                    hu: compatibleUnits,
                    reason: this.selectedReason,
                    batches: batch,
                    list_batch: [],
                    quantity: quantity,
                    max_quantity: quantity,
                  },
                ],
                allow_partial: line.allow_partial,
              });
            }
          });
          line.adjusted_quantity = 0;
          line.is_all_batch = true;
        });
        this.optionReason = this.optionReasonMain.filter(
          (reason) => reason.reason_group == "POD Failed"
        );
        this.ComboMaster.forEach((tr) => {
          tr.reason = this.selectedReason;
          tr.combo_quantity_rejected = tr.combo_quantity_real;
          tr.combo_quantity_accepted = 0;
        });
      } else if (this.selectedStatus.ID == 1) {
        this.calculatePromotion = true;

        this.selectedReason = 0;
        this.RejectedReason = [];
        this.itemLine.forEach((tr) => {
          // tr.adjusted_quantity = tr.quantity;
          this.disabledReason = true;
          this.disableRejectAndAccept = true;
          tr.reason_id = null;
          tr.notes = null;
          tr.is_all_batch = false;

          // tr.item_units.sort((a, b) => b.level - a.level);

          // for (let index = 0; index < tr.item_units.length; index++) {
          //   if (tr.qty_after_conv % tr.item_units[index].amount_uom == 0) {
          //     tr.accepted_item = tr.item_units[index];
          //     tr.adjusted_quantity =
          //       tr.qfter_conv / tr.item_units[index].amount_uom;
          //     tr.return_quantity = 0;
          //     break;
          //   }
          // }
          tr.accepted_item = tr.item_units.find((unit) => unit.level === 1);
          tr.adjusted_quantity = tr.quantity;
          tr.return_quantity = 0;

          //for rejected reason set to 0
          this.RejectedReason.push({
            item_id: tr.item_id,
            item_unit: tr.item_unit,
            combo_id: tr.combo_id,
            is_reguler: tr.is_reguler,
            is_combo: tr.is_combo,
            is_free: tr.is_free,
            list_batch: tr.batches,
            hu_rejected: [
              {
                hu: null,
                reason: null,
                batches: null,
                list_batch: [],
                quantity: 0,
                max_quantity: 0,
              },
            ],
            allow_partial: tr.allow_partial,
          });
        });
        this.itemCombo.forEach((tr) => {
          // tr.adjusted_quantity = tr.quantity;
          this.disabledReason = true;
          this.disableRejectAndAccept = true;
          tr.reason_id = null;
          tr.notes = null;
          tr.is_all_batch = false;

          // For combo items, use level 1 unit (PC) like itemLine
          // This ensures consistency with item_unit field
          tr.accepted_item = tr.item_units.find((unit) => unit.level === 1);
          tr.adjusted_quantity = tr.quantity;
          tr.return_quantity = 0;

          //for rejected reason set to 0
          this.RejectedReason.push({
            item_id: tr.item_id,
            item_unit: tr.item_unit,
            combo_id: tr.combo_id,
            is_reguler: tr.is_reguler,
            is_combo: tr.is_combo,
            is_free: tr.is_free,
            list_batch: tr.batches,
            hu_rejected: [
              {
                hu: null,
                reason: null,
                batches: null,
                list_batch: [],
                quantity: 0,
                max_quantity: 0,
              },
            ],
            allow_partial: tr.allow_partial,
          });
        });
        this.itemFree.forEach((tr) => {
          // tr.adjusted_quantity = tr.quantity;
          this.disabledReason = true;
          this.disableRejectAndAccept = true;
          tr.reason_id = null;
          tr.notes = null;
          tr.is_all_batch = false;

          // tr.item_units.sort((a, b) => b.level - a.level);

          // for (let index = 0; index < tr.item_units.length; index++) {
          //   if (tr.qty_after_conv % tr.item_units[index].amount_uom == 0) {
          //     tr.accepted_item = tr.item_units[index];
          //     tr.adjusted_quantity =
          //       tr.qty_after_conv / tr.item_units[index].amount_uom;
          //     tr.return_quantity = 0;
          //     break;
          //   }
          // }
          tr.accepted_item = tr.item_units.find((unit) => unit.level === 1);
          tr.adjusted_quantity = tr.quantity;
          tr.return_quantity = 0;

          //for rejected reason set to 0
          this.RejectedReason.push({
            item_id: tr.item_id,
            item_unit: tr.item_unit,
            combo_id: tr.combo_id,
            is_reguler: tr.is_reguler,
            is_combo: tr.is_combo,
            is_free: tr.is_free,
            list_batch: tr.batches,
            hu_rejected: [
              {
                hu: null,
                reason: null,
                batches: null,
                list_batch: [],
                quantity: 0,
                max_quantity: 0,
              },
            ],
            allow_partial: tr.allow_partial,
          });
        });
        this.ComboMaster.forEach((tr) => {
          tr.reason = null;
          tr.combo_quantity_rejected = 0;
          tr.combo_quantity_accepted = tr.combo_quantity_real;
        });
      } else if (this.selectedStatus.ID == 2) {
        if (this.itemFree.length > 0) {
          this.calculatePromotion = false;
        } else {
          this.calculatePromotion = true;
        }

        this.RejectedReason = [];

        this.itemLine.forEach((tr) => {
          this.disabledReason = false;
          this.disableRejectAndAccept = false;
          tr.is_all_batch = false;
          tr.reason_id = null;
          tr.notes = null;
          tr.item_units.sort((a, b) => a.level - b.level);
          for (let index = 0; index < tr.item_units.length; index++) {
            if (tr.item_units[index].level == 1) {
              tr.accepted_item = tr.item_units[index];
              tr.adjusted_quantity = tr.quantity;
              tr.return_quantity = 0;
              break;
            }
          }

          this.RejectedReason.push({
            item_id: tr.item_id,
            item_unit: tr.item_unit,
            combo_id: tr.combo_id,
            is_reguler: tr.is_reguler,
            is_combo: tr.is_combo,
            is_free: tr.is_free,
            list_batch: tr.batches,
            max_reason_added: tr.batches.length,
            hu_rejected: [
              {
                hu: null,
                reason: null,
                batches: null,
                list_batch: [],
                quantity: 0,
                max_quantity: 0,
              },
            ],
            allow_partial: tr.allow_partial,
          });
        });
        this.itemCombo.forEach((tr) => {
          this.disabledReason = false;
          this.disableRejectAndAccept = false;
          tr.reason_id = null;
          tr.notes = null;
          tr.item_units.sort((a, b) => a.level - b.level);
          for (let index = 0; index < tr.item_units.length; index++) {
            if (tr.item_units[index].level == 1) {
              tr.accepted_item = tr.item_units[index];
              tr.adjusted_quantity = tr.quantity;
              tr.return_quantity = 0;
              break;
            }
          }
          //find item_units with level 1 and set to accepted_item
          let itemUnit = null;
          itemUnit = tr.item_units.filter((unit) => unit.level == 1)[0];

          tr.batches.forEach((batch) => {
            const quantity = batch.amount_uom_total / itemUnit.amount_uom;
            //for rejected reason set to 0
            this.RejectedReason.push({
              item_id: tr.item_id,
              item_unit: tr.item_unit,
              combo_id: tr.combo_id,
              combo_quantity_general:
                tr.combo_quantity_general != null
                  ? tr.combo_quantity_general
                  : 0,
              combo_quantity: tr.combo_quantity != null ? tr.combo_quantity : 0,
              combo_code: tr.combo_code != null ? tr.combo_code : 0,
              is_reguler: tr.is_reguler,
              is_combo: tr.is_combo,
              is_free: tr.is_free,
              list_batch: tr.batches,
              hu_rejected: [
                {
                  hu: itemUnit,
                  reason: null,
                  batches: batch,
                  list_batch: [],
                  quantity: 0,
                  max_quantity: quantity,
                },
              ],
              allow_partial: tr.allow_partial,
            });
          });
        });
        this.itemFree.forEach((tr) => {
          this.disabledReason = false;
          this.disableRejectAndAccept = false;
          tr.reason_id = null;
          tr.notes = null;
          tr.is_all_batch = false;

          tr.item_units.sort((a, b) => a.level - b.level);
          for (let index = 0; index < tr.item_units.length; index++) {
            if (tr.item_units[index].level == 1) {
              tr.accepted_item = tr.item_units[index];
              tr.adjusted_quantity = tr.quantity;
              tr.return_quantity = 0;
              break;
            }
          }

          this.RejectedReason.push({
            item_id: tr.item_id,
            item_unit: tr.item_unit,
            combo_id: tr.combo_id,
            is_reguler: tr.is_reguler,
            is_combo: tr.is_combo,
            is_free: tr.is_free,
            list_batch: tr.batches,
            hu_rejected: [
              {
                hu: null,
                reason: null,
                batches: null,
                list_batch: [],
                quantity: 0,
                max_quantity: 0,
              },
            ],
            allow_partial: tr.allow_partial,
          });
        });

        this.optionReason = this.optionReasonMain.filter(
          (reason) => reason.reason_group == "POD Partial"
        );
        this.ComboMaster.forEach((tr) => {
          tr.reason = null;
          tr.combo_quantity_rejected = 0;
          tr.combo_quantity_accepted = tr.combo_quantity_real;
        });
      } else {
        this.disabledReason = true;
        this.disableRejectAndAccept = true;
      }

      console.log(">>>>>items status", this.itemLine);
      console.log("rejectedReason", this.RejectedReason);
      // Recalculate conversions after status selection
      this.itemLine.forEach((item) => {
        if (item.adjusted_quantity >= 0) {
          this.applyQuantityConversion(item);
        }
      });
      this.itemCombo.forEach((item) => {
        if (item.adjusted_quantity >= 0) {
          this.applyQuantityConversion(item);
        }
      });
      this.itemFree.forEach((item) => {
        if (item.adjusted_quantity >= 0) {
          this.applyQuantityConversion(item);
        }
      });
      console.log("rejectedReason", this.RejectedReason);
    },

    rejectedCheck(linehead, item_id, item) {
      if (this.itemFree.length > 0) {
        this.calculatePromotion = false;
      } else {
        this.calculatePromotion = true;
      }

      console.log(">>>>>rejectedCheck - linehead:", linehead);
      console.log(">>>>>rejectedCheck - item_id:", item_id);
      console.log(">>>>>rejectedCheck - item:", item);
      console.log(">>>>>rejectedCheck - RejectedReason:", this.RejectedReason);

      let data = this.RejectedReason.filter(
        (items) =>
          items.item_id == item_id &&
          items.item_unit == linehead.item_unit &&
          items.is_reguler == linehead.is_reguler &&
          items.is_free == linehead.is_free
      )[0];

      if (!data) {
        console.error(">>>>>rejectedCheck - No data found for item:", item_id);
        return;
      }

      // Validate quantity input
      if (Number(item.quantity) > Number(item.max_quantity)) {
        this.$vs.notify({
          title: "Error",
          text: "Total quantity input can't be greater than Total Qty this Batch",
          color: "danger",
          position: "top-right",
        });
        item.quantity = Number(item.max_quantity);

        // Recalculate after correction
        let totQtyAfterCorrection = data.hu_rejected.reduce(
          (total, rejected) => {
            return (
              total +
              (rejected.quantity && rejected.hu
                ? rejected.hu.amount_uom * Number(rejected.quantity)
                : 0)
            );
          },
          0
        );

        linehead.adjusted_quantity = Math.max(
          0,
          linehead.quantity - totQtyAfterCorrection
        );
        this.updateIsAllBatch(linehead);
        this.applyQuantityConversion(linehead);
        return;
      }

      if (Number(item.quantity) < 0) {
        this.$vs.notify({
          title: "Error",
          text: "Total quantity input can't be less than 0",
          color: "danger",
          position: "top-right",
        });
        item.quantity = 0;
      }

      // Calculate total rejected quantity (convert all to base unit - level 1)
      let totalRejectedQty = data.hu_rejected.reduce((total, rejected) => {
        if (rejected.quantity && rejected.hu) {
          const qtyInBaseUnit =
            rejected.hu.amount_uom * Number(rejected.quantity);
          console.log(
            `>>>>>Rejected item: ${rejected.quantity} x ${rejected.hu.unit_name} (${rejected.hu.amount_uom}) = ${qtyInBaseUnit} base units`
          );
          return total + qtyInBaseUnit;
        }
        return total;
      }, 0);

      console.log(">>>>>rejectedCheck - Total Rejected Qty:", totalRejectedQty);
      console.log(">>>>>rejectedCheck - Original Quantity:", linehead.quantity);

      // Calculate adjusted quantity: original quantity - total rejected quantity
      let newAdjustedQty = linehead.quantity - totalRejectedQty;

      // Ensure adjusted quantity is not negative
      if (newAdjustedQty < 0) {
        this.$vs.notify({
          title: "Error",
          text: "Total rejected quantity exceeds available quantity",
          color: "danger",
          position: "top-right",
        });
        // Reset to maximum allowed rejection
        newAdjustedQty = 0;
        item.quantity = Math.floor(
          (linehead.quantity -
            (totalRejectedQty -
              (item.hu ? item.hu.amount_uom * Number(item.quantity) : 0))) /
            (item.hu ? item.hu.amount_uom : 1)
        );

        // Recalculate after correction
        totalRejectedQty = data.hu_rejected.reduce((total, rejected) => {
          return (
            total +
            (rejected.quantity && rejected.hu
              ? rejected.hu.amount_uom * Number(rejected.quantity)
              : 0)
          );
        }, 0);

        newAdjustedQty = Math.max(0, linehead.quantity - totalRejectedQty);
      }

      linehead.adjusted_quantity = newAdjustedQty;

      console.log(
        ">>>>>rejectedCheck - New Adjusted Quantity:",
        newAdjustedQty
      );

      // Update is_all_batch status
      this.updateIsAllBatch(linehead);

      // Apply quantity conversion after calculating adjusted_quantity
      if (linehead.adjusted_quantity >= 0) {
        this.applyQuantityConversion(linehead);
      }
    },
    handleSelectReason() {
      //set all reason_id on itemLine.rejected_reason to selectedReason
      const updateRejectedReasons = (items, reason) => {
        if (items == this.ComboMaster) {
          items.forEach((item) => {
            item.reason = reason;
          });
        } else if (items == this.RejectedReason) {
          items.forEach((item) => {
            item.hu_rejected.forEach((r) => {
              r.reason = reason;
            });
          });
        } else {
          items.forEach((item) => {
            item.rejected_reason.forEach((r) => {
              r.reason = reason;
            });
          });
        }
      };

      // Update rejected reasons for all item groups
      updateRejectedReasons(this.RejectedReason, this.selectedReason);
      updateRejectedReasons(this.itemCombo, this.selectedReason);
      updateRejectedReasons(this.itemFree, this.selectedReason);
      updateRejectedReasons(this.ComboMaster, this.selectedReason);

      // Recalculate conversions after reason selection
      this.itemLine.forEach((item) => {
        if (item.adjusted_quantity >= 0) {
          this.applyQuantityConversion(item);
        }
      });
      this.itemCombo.forEach((item) => {
        if (item.adjusted_quantity >= 0) {
          this.applyQuantityConversion(item);
        }
      });
      this.itemFree.forEach((item) => {
        if (item.adjusted_quantity >= 0) {
          this.applyQuantityConversion(item);
        }
      });
    },
    handleCheckEditOrShow() {
      if (this.$route.query.action == "Show") {
        this.disableRejectAndAccept = true;
        this.disabledReason = true;
        this.editOrShow = true;
      }
    },
    handleCheckIfDelivered() {
      this.disableRejectAndAccept = true;
      this.disabledReason = true;
      this.editOrShow = true;
    },
    addRowReason(item_id, index, item, linehead) {
      // console.log(">>>>111", this.itemLine[indextr].rejected_reason);
      console.log(">>>>item", item);
      let data = this.RejectedReason.filter(
        (items) =>
          items.item_id == item_id &&
          items.item_unit == linehead.item_unit &&
          items.is_reguler == linehead.is_reguler &&
          items.is_free == linehead.is_free &&
          items.is_combo == linehead.is_combo
      )[0];

      //check before add new data hu_rejected if form hu_rejected have value null or 0 then set error to fill all form
      let check = data.hu_rejected.filter(
        (item) =>
          item.hu == null ||
          item.reason == null ||
          item.quantity == 0 ||
          item.batches == null
      );
      if (check.length > 0) {
        this.$vs.notify({
          title: "Error",
          text: "Please fill all form",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      //append new data default hu_rejected  in data
      let newData = {
        hu: null,
        reason: this.selectedReason,
        batches: null,
        quantity: 0,
        max_quantity: 0,
        list_batch: [],
      };
      data.hu_rejected.push(newData);

      console.log(
        `Added new row for item ${item_id}. Total rows: ${data.hu_rejected.length}`
      );
      // if (data.hu_rejected.length > data.max_reason_added) {
      //   this.$vs.notify({
      //     title: "Error",
      //     text: `You can only add ${data.max_reason_added} row(s).`,
      //     color: "danger",
      //     position: "top-right",
      //   });
      //   this.$nextTick(() => {
      //     this.$refs[`hu_rejected_${item_id}`][index].blur();
      //   });
      // }
    },
    removeRowReason(item_id, index, item, linehead) {
      // Remove rejected reason at the specified index
      console.log(">>>>item", item);
      console.log(">>>>item_id", item_id);
      console.log(">>>>index", index);
      console.log(">>>>linehead", linehead);
      console.log(">>>>RejectedReason", this.RejectedReason);

      //find item id in RejectedReason
      let data = this.RejectedReason.filter(
        (items) =>
          items.item_id == item_id &&
          items.item_unit == linehead.item_unit &&
          items.is_reguler == linehead.is_reguler &&
          items.is_free == linehead.is_free &&
          items.is_combo == linehead.is_combo &&
          items.allow_partial == linehead.allow_partial
      )[0];
      console.log(">>>>data", data);

      //convert to level 1
      if (item.hu != null) {
        let qty = item.quantity;
        if (item.hu.level != 1) {
          qty = item.quantity * item.hu.amount_uom;
        }
        console.log(">>>>qtybosssss", qty);
        const adjqty = linehead.adjusted_quantity;
        console.log(">>>>adjqty", adjqty);
        linehead.adjusted_quantity = Number(adjqty) + Number(qty);
        this.calculatePromotion = false;
      }
      console.log(">>>>lineheadV2", linehead);
      //  clear all data on data.hu_rejected
      data.hu_rejected.splice(index, 1);

      console.log(
        `Removed row for item ${item_id}. Remaining rows: ${data.hu_rejected.length}`
      );

      // Update is_all_batch using helper function
      this.updateIsAllBatch(linehead);
      // Apply quantity conversion after calculating adjusted_quantity
      if (linehead.adjusted_quantity >= 0) {
        this.applyQuantityConversion(linehead);
      }
    },
    rejectedComboCheck(indextr, comboID) {
      if (this.itemFree.length > 0) {
        this.calculatePromotion = false;
      } else {
        this.calculatePromotion = true;
      }

      //change value combo_quantity every change
      this.ComboMaster[indextr].combo_quantity =
        this.ComboMaster[indextr].combo_quantity_real -
        this.ComboMaster[indextr].combo_quantity_rejected;

      this.ComboMaster[indextr].combo_quantity_accepted =
        this.ComboMaster[indextr].combo_quantity_real -
        this.ComboMaster[indextr].combo_quantity_rejected;

      if (
        this.ComboMaster[indextr].combo_quantity < 0 ||
        this.ComboMaster[indextr].combo_quantity >
          this.ComboMaster[indextr].combo_quantity_real
      ) {
        this.$vs.notify({
          title: "Error",
          text: "Total quantity input can't be greater than Total Qty or less than 0",
          color: "danger",
          position: "top-right",
        });
        this.ComboMaster[indextr].combo_quantity = 0;
        this.ComboMaster[indextr].combo_quantity_rejected =
          this.ComboMaster[indextr].combo_quantity_real;
        this.ComboMaster[indextr].combo_quantity_accepted = 0;
      }

      const combo = this.RejectedReason.filter(
        (item) => item.combo_id === comboID
      );

      console.log(">>>>>rejectedComboCheck - Processing combo:", comboID);
      console.log(
        ">>>>>rejectedComboCheck - Combo Rejected:",
        this.ComboMaster[indextr].combo_quantity_rejected
      );
      console.log(
        ">>>>>rejectedComboCheck - Combo Accepted:",
        this.ComboMaster[indextr].combo_quantity
      );

      this.itemCombo
        .filter((item) => item.combo_id === comboID)
        .forEach((item2) => {
          console.log("\n>>>>>Processing SKU:", item2.item_code);

          // Calculate total rejected quantity for this SKU
          const totalRejectedQty =
            this.ComboMaster[indextr].combo_quantity_rejected *
            item2.combo_quantity_general;

          // Calculate total accepted quantity for this SKU
          const totalAcceptedQty =
            this.ComboMaster[indextr].combo_quantity *
            item2.combo_quantity_general;

          console.log(">>>>>Total Rejected Qty:", totalRejectedQty);
          console.log(">>>>>Total Accepted Qty:", totalAcceptedQty);
          console.log(">>>>>Original Quantity:", item2.quantity);

          // Update item adjusted_quantity
          item2.adjusted_quantity = totalAcceptedQty;

          // Sort batches by amount_uom_total in DESCENDING order (largest first)
          const sortedBatches = [...item2.batches].sort(
            (a, b) => b.amount_uom_total - a.amount_uom_total
          );

          console.log(
            ">>>>>Sorted Batches (largest first):",
            sortedBatches.map((b) => ({
              batch: b.batches,
              qty: b.amount_uom_total,
            }))
          );

          // Distribute REJECTED quantity to batches starting from LARGEST
          let remainingRejectedQty = totalRejectedQty;

          // Find level 1 unit for this item
          const level1Unit = item2.item_units.find((unit) => unit.level === 1);

          // Array to collect rejected batches
          const rejectedBatches = [];

          sortedBatches.forEach((batch, index) => {
            if (remainingRejectedQty <= 0) {
              // No rejection for this batch - fully accepted
              batch.adjusted_quantity = batch.amount_uom_total;
              console.log(
                `  Batch ${index + 1} (${batch.batches}): ${
                  batch.adjusted_quantity
                } / ${batch.amount_uom_total} (fully accepted, no rejection)`
              );
            } else if (remainingRejectedQty >= batch.amount_uom_total) {
              // This batch is FULLY REJECTED
              const rejectedQtyInBaseUnit = batch.amount_uom_total;
              batch.adjusted_quantity = 0;
              remainingRejectedQty -= batch.amount_uom_total;

              // Add to rejected batches array
              if (level1Unit) {
                rejectedBatches.push({
                  hu: level1Unit,
                  reason: null, // Will be set from ComboMaster reason
                  batches: batch,
                  list_batch: item2.batches,
                  quantity: rejectedQtyInBaseUnit / level1Unit.amount_uom,
                  max_quantity: batch.amount_uom_total / level1Unit.amount_uom,
                  rejected_amount: rejectedQtyInBaseUnit,
                });
              }

              console.log(
                `  Batch ${index + 1} (${batch.batches}): 0 / ${
                  batch.amount_uom_total
                } (fully rejected, remaining rejection: ${remainingRejectedQty})`
              );
            } else {
              // This batch is PARTIALLY REJECTED
              const rejectedQtyInBaseUnit = remainingRejectedQty;
              batch.adjusted_quantity =
                batch.amount_uom_total - remainingRejectedQty;

              // Add to rejected batches array
              if (level1Unit) {
                rejectedBatches.push({
                  hu: level1Unit,
                  reason: null, // Will be set from ComboMaster reason
                  batches: batch,
                  list_batch: item2.batches,
                  quantity: rejectedQtyInBaseUnit / level1Unit.amount_uom,
                  max_quantity: batch.amount_uom_total / level1Unit.amount_uom,
                  rejected_amount: rejectedQtyInBaseUnit,
                });
              }

              console.log(
                `  Batch ${index + 1} (${batch.batches}): ${
                  batch.adjusted_quantity
                } / ${
                  batch.amount_uom_total
                } (partial - rejected ${remainingRejectedQty}, accepted ${
                  batch.adjusted_quantity
                })`
              );
              remainingRejectedQty = 0;
            }
          });

          console.log(">>>>>Rejected Batches:", rejectedBatches);

          console.log(">>>>>Rejected Batches:", rejectedBatches);

          // Update RejectedReason for this item
          const rejectedReasonItem = combo.find(
            (c) =>
              c.item_id === item2.item_id &&
              c.combo_id === comboID &&
              c.combo_quantity_general === item2.combo_quantity_general
          );

          if (rejectedReasonItem) {
            // Replace hu_rejected with the new rejected batches array
            if (rejectedBatches.length > 0) {
              // Set reason from ComboMaster if available
              const comboReason = this.ComboMaster[indextr].reason;
              rejectedBatches.forEach((rejected) => {
                rejected.reason = comboReason;
              });

              rejectedReasonItem.hu_rejected = rejectedBatches;
              console.log(
                ">>>>>Updated RejectedReason with rejected batches:",
                rejectedReasonItem.hu_rejected
              );
            } else {
              // No rejection - add default empty row
              rejectedReasonItem.hu_rejected = [
                {
                  hu: null,
                  reason: null,
                  batches: null,
                  list_batch: item2.batches,
                  quantity: 0,
                  max_quantity: 0,
                },
              ];
              console.log(">>>>>No rejection - added default empty row");
            }
          } else {
            console.warn(
              ">>>>>RejectedReason item not found for:",
              item2.item_code
            );
          }

          // Update is_all_batch status based on adjusted_quantity
          this.updateIsAllBatch(item2);

          console.log(
            ">>>>>Final item adjusted_quantity:",
            item2.adjusted_quantity
          );
          console.log(
            ">>>>>Final batches:",
            item2.batches.map((b) => ({
              batch: b.batches,
              original: b.amount_uom_total,
              adjusted: b.adjusted_quantity,
            }))
          );
        });

      // this.itemCombo.forEach((element) => {
      //   element.rejected_reason[0].batch_rejected = element.batches[0];
      //   element.rejected_reason[0].delivery_order_line_id =
      //     element.batches[0].delivery_order_line_id;
      // });

      console.log(">>>>>ItemCombo", this.itemCombo);
      // Clean up default rows from all RejectedReason items
      this.cleanupAllRejectedReasons();

      // Apply conversion for combo items
      this.itemCombo.forEach((item) => {
        if (item.adjusted_quantity >= 0) {
          this.applyQuantityConversion(item);
        }
      });
    },
    rejectedComboCheckReason(indextr, comboID) {
      let combo = this.RejectedReason.filter(
        (item) => item.combo_id == comboID
      );
      combo.forEach((item) => {
        item.hu_rejected.forEach((rejected) => {
          rejected.reason = this.ComboMaster[indextr].reason;
        });
      });
    },
    selectBatch(linehead, item_id, item) {
      if (this.itemFree.length > 0) {
        this.calculatePromotion = false;
      } else {
        this.calculatePromotion = true;
      }

      console.log(">>>>>item", item);
      console.log(">>>>>data Item", linehead);

      //find RejectedReason with item_id
      let data = this.RejectedReason.filter(
        (items) =>
          items.item_id == item_id &&
          items.item_unit == linehead.item_unit &&
          items.is_reguler == linehead.is_reguler &&
          items.is_free == linehead.is_free &&
          items.is_combo == linehead.is_combo &&
          items.combo_id == linehead.combo_id
      )[0];

      console.log(">>>>>data", data);
      //check on data.hu_rejected if found same delivery_order_line_id == item.batches.delivery_order_line_id
      let foundData = null;
      if (data) {
        foundData = data.hu_rejected.filter(
          (items) =>
            items.batches.delivery_order_line_id ==
            item.batches.delivery_order_line_id
        );
        if (foundData.length > 1) {
          const QtyTot = foundData.reduce(
            (total, element) =>
              total + Number(element.quantity) * element.hu.amount_uom,
            0
          );
          const sisaQty = item.batches.amount_uom_total - QtyTot;

          foundData.forEach((element) => {
            element.max_quantity =
              element.batches.delivery_order_line_id ===
              item.batches.delivery_order_line_id
                ? element.quantity
                : element.quantity;
          });

          item.max_quantity = sisaQty / item.hu.amount_uom;
        } else {
          item.quantity = 0;
          item.reason = null;
          const maxQty =
            Number(item.batches.amount_uom_total) / Number(item.hu.amount_uom);

          if (
            Number(item.batches.amount_uom_total) < Number(item.hu.amount_uom)
          ) {
            this.$vs.notify({
              title: "Error",
              text: "Please change another HU",
              color: "danger",
              position: "top-right",
            });
            item.quantity = 0;
            item.hu = null;
          }

          item.max_quantity = maxQty;
        }
      }

      // Apply conversion after batch selection
      if (linehead.adjusted_quantity >= 0) {
        this.applyQuantityConversion(linehead);
      }
    },
    customLabelBatch({ batch_external }) {
      return `${batch_external}`;
    },
    selectHU(linehead, item_id, index, item) {
      console.log(">>>>>item", item);
      if (this.itemFree.length > 0) {
        this.calculatePromotion = false;
      } else {
        this.calculatePromotion = true;
      }

      item.batches = null;
      item.quantity = 0;
      item.max_quantity = 0;
      item.reason = null;

      let data = this.RejectedReason.filter(
        (items) =>
          items.item_id == item_id &&
          items.item_unit == linehead.item_unit &&
          items.is_reguler == linehead.is_reguler &&
          items.is_free == linehead.is_free &&
          items.is_combo == linehead.is_combo
      )[0];
      console.log(">>>>>data", data);

      // let filterbatch = [];
      // if (data.hu_rejected.length > 1) {
      //   filterbatch = data.list_batch.filter(
      //     (items) =>
      //       items.delivery_order_line_id !=
      //       data.hu_rejected[0].batches.delivery_order_line_id
      //   );
      // } else {
      //   filterbatch = data.list_batch;
      // }
      // console.log(">>>>>filterbatch", filterbatch);
      item.list_batch = data.list_batch;
    },
    handleDetailsCombo(index) {
      this.isDetailCombo = !this.isDetailCombo;
      this.detailCombo = [];
      this.detailCombo = this.itemCombo.filter(
        (item) => item.combo_id == index
      );
    },
    handleAllBatch(linehead, item_id, indextr, dataFG) {
      // Set calculate promotion flag based on itemFree
      if (this.itemFree.length > 0) {
        this.calculatePromotion = false;
      } else {
        this.calculatePromotion = true;
      }

      // Check if indextr is 99 then set selectedReason to reason id 47
      if (indextr == 99) {
        this.selectedReason = this.optionReasonMain.find(
          (reason) => reason.id == 47
        );
      }

      // Filter RejectedReason data for current item
      let data = this.RejectedReason.filter(
        (items) =>
          items.item_id == item_id &&
          items.item_unit == linehead.item_unit &&
          items.is_reguler == linehead.is_reguler &&
          items.is_free == linehead.is_free &&
          items.is_combo == linehead.is_combo &&
          items.allow_partial == linehead.allow_partial
      );

      console.log(">>>>>handleAllBatch - data:", data);
      console.log(">>>>>handleAllBatch - linehead:", linehead);
      console.log(">>>>>handleAllBatch - is_all_batch:", linehead.is_all_batch);

      // Remove duplicates if length > 1
      if (data.length > 1) {
        data.forEach((item, index) => {
          if (index > 0) {
            this.RejectedReason.splice(this.RejectedReason.indexOf(item), 1);
          }
        });
      }

      // Safety check - ensure data exists
      if (!data || data.length === 0) {
        console.error(">>>>>handleAllBatch - No data found for item:", item_id);
        return;
      }

      // Find hu level 1 in linehead.item_units
      const huLevel1 = linehead.item_units.find((item) => item.level === 1);

      if (!huLevel1) {
        console.error(">>>>>handleAllBatch - No level 1 unit found");
        return;
      }

      // Special case for promotion calculation (indextr == 99)
      if (indextr == 99) {
        // Clear existing hu_rejected array for promotion case
        data[0].hu_rejected = [];
        // Append all batches to hu_rejected
        if (huLevel1) {
          let adjQTY = 0;
          let counthaverejected = 0;
          linehead.batches.forEach((batch) => {
            console.log(">>>>>batch", batch);
            console.log(">>>>>dataFG", dataFG);
            let quantityTotal = batch.amount_uom_total / huLevel1.amount_uom;

            // Flag to track if this batch was processed
            let batchProcessed = false;
            let batchRemainingQty = quantityTotal; // Track remaining qty to allocate in this batch

            dataFG.forEach((fg) => {
              // Skip if batch already fully allocated or FG has no remaining qty
              if (batchRemainingQty <= 0 || fg.qty_uom <= 0) {
                return;
              }

              let totQtyAdjFG = fg.qty_uom;

              // Check if current item (linehead) is the RECEIVER of this free good
              // Match by item_code only, aggregate ALL free goods for this item regardless of unit
              // This allows item with unit PC to receive free good from both PC and KAR promotions
              const isFreeGoodItem = fg.item_code === linehead.item_code;

              console.log(
                ">>>>>Checking match - linehead.item_code:",
                linehead.item_code,
                "linehead.item_unit:",
                linehead.item_unit,
                "huLevel1.item_unit:",
                huLevel1.item_unit,
                "linehead.item_id:",
                linehead.item_id,
                "fg.item_code:",
                fg.item_code,
                "fg.item_unit:",
                fg.item_unit,
                "fg.qty_uom:",
                totQtyAdjFG,
                "batchRemainingQty:",
                batchRemainingQty,
                "fg.related_item_id:",
                fg.related_item_id,
                "fg.source_item_code:",
                fg.source_item_code,
                "isFreeGoodItem:",
                isFreeGoodItem
              );

              if (isFreeGoodItem && totQtyAdjFG > 0) {
                batchProcessed = true;
                console.log(">>>>>quantityTotal", quantityTotal);
                console.log(">>>>>batchRemainingQty", batchRemainingQty);
                console.log(">>>>>fg.qty_uom", totQtyAdjFG);

                if (totQtyAdjFG < batchRemainingQty) {
                  // Free good quantity is less than remaining batch quantity
                  // Accept only the free good quantity, continue to next FG entry
                  console.log(">>>>>Case 1: Free good < remaining batch qty");
                  linehead.is_all_batch = false;

                  adjQTY += totQtyAdjFG;
                  batchRemainingQty -= totQtyAdjFG; // Reduce remaining batch qty
                  fg.qty_uom = 0; // All FG used up
                } else {
                  // Free good quantity is more than or equal to remaining batch quantity
                  // Accept all remaining batch quantity
                  console.log(">>>>>Case 2: Free good >= remaining batch qty");

                  adjQTY += batchRemainingQty;
                  fg.qty_uom -= batchRemainingQty; // Reduce FG by batch amount
                  batchRemainingQty = 0; // Batch fully allocated

                  // No rejection needed for this batch
                  if (linehead.batches.length > 1) {
                    linehead.is_all_batch = false;
                  }
                }

                counthaverejected += 1;
              }
            });

            // After processing all FG, check if there's remaining batch qty to reject
            if (batchRemainingQty > 0) {
              console.log(
                ">>>>>Batch has remaining qty to reject:",
                batchRemainingQty,
                "(batch total:",
                quantityTotal,
                ")"
              );
              data[0].hu_rejected.push({
                hu: huLevel1,
                reason: this.selectedReason,
                batches: batch,
                quantity: batchRemainingQty,
                max_quantity: quantityTotal,
                list_batch: linehead.batches,
              });
            }

            console.log(">>>>>hu_rejected after batch", data[0].hu_rejected);
            console.log(">>>>>fg remaining", dataFG);
            console.log(">>>>>batchProcessed", batchProcessed);
          });

          if (counthaverejected == 0) {
            // No free good found for this item
            // Check if this item is actually in the free good list (match by code only)
            const isActuallyFreeGood = dataFG.some(
              (fg) => fg.item_code === linehead.item_code
            );

            if (isActuallyFreeGood) {
              // This item should receive free good but qty is 0, reject all
              console.log(
                ">>>>>Item is in free good list but qty=0, rejecting all batches"
              );
              linehead.batches.forEach((batch) => {
                data[0].hu_rejected.push({
                  hu: huLevel1,
                  reason: this.selectedReason,
                  batches: batch,
                  quantity: batch.amount_uom_total / huLevel1.amount_uom,
                  max_quantity: batch.amount_uom_total / huLevel1.amount_uom,
                  list_batch: linehead.batches,
                });
              });
              linehead.is_all_batch = true;
            } else {
              // This item is NOT a free good receiver, add single default empty row
              console.log(
                ">>>>>Item NOT in free good list, adding single default empty row"
              );
              data[0].hu_rejected.push({
                hu: null,
                reason: null,
                batches: null,
                quantity: 0,
                max_quantity: 0,
                list_batch: linehead.batches,
              });
              linehead.is_all_batch = false;
              linehead.adjusted_quantity = 0;
            }
          }

          // Determine is_all_batch based on adjQTY
          // Convert adjQTY (in PC/smallest unit) to linehead's unit for proper comparison
          const adjQTYConverted = adjQTY / huLevel1.amount_uom;

          console.log(">>>>>adjQTY (PC):", adjQTY);
          console.log(">>>>>huLevel1.amount_uom:", huLevel1.amount_uom);
          console.log(">>>>>adjQTYConverted:", adjQTYConverted);
          console.log(">>>>>linehead.quantity:", linehead.quantity);

          if (adjQTY == 0) {
            linehead.is_all_batch = true;
            linehead.adjusted_quantity = 0;
          } else if (adjQTYConverted >= linehead.quantity) {
            // All quantity accepted - CLEAR any partial rejections created during batch loop
            linehead.is_all_batch = false;
            linehead.adjusted_quantity = linehead.quantity;

            // Clear all rejections since full quantity is accepted
            data[0].hu_rejected = [];

            // Add default empty row to show no rejection
            console.log(
              ">>>>>All accepted, clearing rejections and adding default empty row"
            );
            data[0].hu_rejected.push({
              hu: null,
              reason: null,
              batches: null,
              quantity: 0,
              max_quantity: 0,
              list_batch: linehead.batches,
            });
          } else {
            linehead.is_all_batch = false;
            linehead.adjusted_quantity = adjQTYConverted;
          }

          console.log(">>>>>Final adjQTY:", adjQTY);
          console.log(">>>>>Final is_all_batch:", linehead.is_all_batch);
          console.log(
            ">>>>>Final adjusted_quantity:",
            linehead.adjusted_quantity
          );

          // Apply conversion
          this.applyQuantityConversion(linehead);
        }
      } else {
        // Normal case - handle toggle switch ON/OFF
        if (linehead.is_all_batch) {
          // When switch is turned ON - Reject all batches
          // Clear existing hu_rejected array before adding new rejections
          data[0].hu_rejected = [];

          if (huLevel1) {
            linehead.batches.forEach((batch) => {
              data[0].hu_rejected.push({
                hu: huLevel1,
                reason: this.selectedReason,
                batches: batch,
                quantity: batch.amount_uom_total / huLevel1.amount_uom,
                max_quantity: batch.amount_uom_total / huLevel1.amount_uom,
                list_batch: linehead.batches,
              });
            });
            // Set adjusted_quantity to 0 (all rejected)
            linehead.adjusted_quantity = 0;
            // Update is_all_batch (should be true)
            this.updateIsAllBatch(linehead);

            // Apply conversion when all batches are rejected
            this.applyQuantityConversion(linehead);
          }
        } else {
          // When switch is turned OFF - Reset to original quantity
          // Clear all rejected items
          data[0].hu_rejected = [];

          // Add single default empty rejection entry
          data[0].hu_rejected.push({
            hu: null,
            reason: null,
            batches: null,
            quantity: 0,
            max_quantity: 0,
            list_batch: linehead.batches,
          });

          // Reset adjusted_quantity to original quantity (all accepted)
          linehead.adjusted_quantity = linehead.quantity;
          // Update is_all_batch (should be false)
          this.updateIsAllBatch(linehead);

          // Apply conversion when batch is turned off
          this.applyQuantityConversion(linehead);
        }
      }

      // Apply conversion after handling all batches
      if (linehead.adjusted_quantity >= 0) {
        this.applyQuantityConversion(linehead);
      }

      // Clean up default rows for this specific item
      if (data && data.length > 0) {
        this.cleanupDefaultRows(data[0]);
        console.log(
          `handleAllBatch cleanup for item ${item_id}. hu_rejected count: ${data[0].hu_rejected.length}`
        );
      }
    },
    handleCalculatePromotion() {
      // append data to new array
      let deliveryOrderID = this.table.data.delivery_order_id;
      let salesOrderCodes = this.table.data.sales_order_code;
      let statusDelivery = this.selectedStatus.ID;

      if (statusDelivery == 0) {
        this.$vs.notify({
          title: "Error",
          text: "Please select status delivery",
          color: "warning",
          position: "top-right",
        });
        return;
      }

      // Use a Map for fast lookup by delivery_order_line_id
      const detailCalculateMap = new Map();

      // Helper to get level 1 unit
      const getLevel1Unit = (units) => units.find((u) => u.level === 1);

      console.log(">>>>>itemLine", this.itemLine);
      console.log(">>>>>itemCombo", this.itemCombo);

      // Process itemLine and itemCombo together for less code repetition
      [this.itemLine, this.itemCombo].forEach((list) => {
        list.forEach((element) => {
          const itemUnit = getLevel1Unit(element.item_units);
          if (!itemUnit) return;
          let totalqtyamountuom =
            element.adjusted_quantity * itemUnit.amount_uom;
          element.batches.forEach((batch) => {
            const key = batch.delivery_order_line_id;
            // Calculate adjusted_quantity before creating the object
            let calculatedAdjustedQuantity = 0;
            if (totalqtyamountuom > 0) {
              // Calculate how much we can take from this batch
              const batchAdjustedQty = Math.min(
                batch.amount_uom_total,
                totalqtyamountuom
              );
              calculatedAdjustedQuantity = batchAdjustedQty;
              totalqtyamountuom -= batchAdjustedQty; // Reduce the remaining qty for next batches
            } else {
              calculatedAdjustedQuantity = 0; // No more quantity to distribute
            }

            const obj = {
              delivery_order_line_id: key,
              item_code: element.item_code,
              item_unit: itemUnit.unit_name,
              item_unit_id: itemUnit.id,
              item_id: element.item_id,
              adjusted_quantity: calculatedAdjustedQuantity,
              quantity: batch.amount_uom_total,
              combo_id: element.combo_id,
              free_item: element.is_free,
            };
            detailCalculateMap.set(key, obj);
          });
        });
      });
      console.log(">>>>>detailCalculateMap1", detailCalculateMap);

      console.log(">>>>>detailCalculateMap2", detailCalculateMap);

      // Convert map to array
      const detailCalculateArr = Array.from(detailCalculateMap.values());

      // this.FGItem = [];
      var ItemUnitUOM = [];

      this.itemFree.forEach((element) => {
        console.log("ini elementfree", element);
        element.item_units.forEach((unit) => {
          // Collect all item units for ItemUnitUOM
          ItemUnitUOM.push({
            id: unit.id,
            item_id: element.item_id,
            item_code: element.item_code,
            item_unit: unit.unit_name,
            amount_uom: unit.amount_uom,
          });
        });
        console.log(">>>>>free item", ItemUnitUOM);
        // grouping by item code on FGItem for
        // Example: Item 1A = 2 KAR (24 PC), Item 2A =2PC (2 PC), Item 3B =3 BOX (15 PC)
        // grouping: Item A =26 PC, Item B =15 PC

        // Assume element.item_code is like "1A", "2A", "3B"
        // and element.qty_after_conv is in PC (after conversion)
        // We'll group by the last character (A, B, etc.)

        // element.batches.forEach((element2) => {
        //   // Get the group key (last character of item_code)
        //   const groupKey =
        //     element.item_code.slice(-5) + element2.delivery_order_line_id;
        //   // Find if already exists
        //   let fg = this.FGItem.find((x) => x.groupKey === groupKey);
        //   if (!fg) {
        //     console.log(">>>>>element2", element2);
        //     this.FGItem.push({
        //       groupKey: groupKey,
        //       item_code: element.item_code,
        //       item_name: element.item_name,
        //       totalQty: element2.amount_uom_total,
        //       item_unit: element.item_units.filter(
        //         (unit) => unit.level == 1
        //       )[0],
        //     });
        //   } else {
        //     console.log(">>>>>fg", fg);
        //     fg.totalQty =
        //       Number(fg.totalQty) + Number(element2.amount_uom_total);
        //     console.log(">>>>>fg2", fg);
        //   }
        // });
      });

      // console.log(">>>>>FGItem", this.FGItem);

      // Example: log the result

      this.prosessingSave = true;
      this.$vs.loading();
      this.$http
        .post("/api/wms/v1/proof-of-delivery/calculate-promo", {
          delivery_order_id: deliveryOrderID,
          sales_order_code: salesOrderCodes,
          status_delivery: statusDelivery,
          data: detailCalculateArr,
        })
        .then((response) => {
          this.$vs.loading.close();
          this.prosessingSave = false;

          if (response.code == 200) {
            this.ItFG = [];
            // Append promotion_free_item to itemFreegood
            if (
              Array.isArray(response.data.line_convertion) &&
              response.data.line_convertion.length > 0
            ) {
              this.$vs.notify({
                title: "Success",
                text: "Calculate Promotion Success",
                color: "success",
                position: "top-right",
              });
              response.data.line_convertion.forEach((item) => {
                if (
                  item.Information &&
                  item.Information.promotion_free_item != null
                ) {
                  item.Information.promotion_free_item.forEach((freeItem) => {
                    //find unit on ItemUnitUOM
                    const unit = ItemUnitUOM.find(
                      (u) =>
                        u.item_code === freeItem.fg_item_code &&
                        u.id === freeItem.fg_item_unit_id
                    );
                    this.ItFG.push({
                      item_code: freeItem.fg_item_code,
                      item_name: freeItem.fg_item_name,
                      item_unit: unit ? unit.item_unit : "",
                      qty: freeItem.fg_qty,
                      qty_uom: unit
                        ? Number(unit.amount_uom) * Number(freeItem.fg_qty)
                        : 0,
                      temp_qty: unit
                        ? Number(unit.amount_uom) * Number(freeItem.fg_qty)
                        : 0,
                      related_item_id: freeItem.related_item_id || [], // Simpan related_item_id
                      source_item_code: item.SkuCode, // Simpan SKU pemberi
                    });
                  });
                }
              });
            } else {
              this.$vs.notify({
                title: "Error",
                text: "This Status Delivery Must be Failed Redeluver or Failed Cancel",
                color: "danger",
                position: "top-right",
              });
            }

            //check duplicate on ItFG if item_code and unit is already exist then sum qty_uom and delete the duplicate
            this.ItFG = this.ItFG.reduce((acc, current) => {
              const x = acc.find(
                (item) =>
                  item.item_code === current.item_code &&
                  item.item_unit === current.item_unit
              );
              if (!x) {
                return acc.concat([current]);
              } else {
                // Sum all quantities
                x.qty_uom += current.qty_uom;
                x.qty += current.qty;
                x.temp_qty += current.temp_qty;
                // Merge related_item_id arrays and remove duplicates
                if (current.related_item_id) {
                  x.related_item_id = [
                    ...new Set([
                      ...(x.related_item_id || []),
                      ...current.related_item_id,
                    ]),
                  ];
                }
              }
              return acc;
            }, []);

            // console.log(">>>>>FGItem1", this.FGItem);
            // console.log(">>>>>ItFG", this.ItFG);
            // this.ItFG.forEach((element) => {
            //   // Sum all qty_uom in ItFG that match the item_code
            //   const matchingFGItem = this.FGItem.filter(
            //     (x) => x.item_code === element.item_code
            //   );
            //   console.log(">>>>>matchingItFG", matchingFGItem);
            //   if (matchingFGItem.length > 0) {
            //     // Sum the qty_uom of matching items
            //     matchingFGItem.forEach((fg) => {
            //       if (fg.totalQty >= element.temp_qty) {
            //         fg.totalQty = element.temp_qty;
            //         element.temp_qty = 0;
            //       } else {
            //         let a = 0;
            //         a = element.temp_qty - fg.totalQty;
            //         if (a < 0) {
            //           a = 0;
            //         } else {
            //           a = fg.totalQty;
            //         }
            //         fg.totalQty = a;
            //         element.temp_qty = a;
            //       }
            //     });
            //   } else {
            //     console.log(">>>>>No matching FGItem found");
            //     // If no matching items, set totalQty to 0 on all FGItem
            //     for (let i = 0; i < this.FGItem.length; i++) {
            //       this.FGItem[i].totalQty = 0;
            //     }
            //   }
            // });
            // console.log(">>>>>FGItem2", this.FGItem);
            console.log(">>>>>ItFG FINAL dengan related_item_id:", this.ItFG);

            // var t = 1;
            this.itemFree.forEach((element) => {
              console.log(
                ">>>>>Processing itemFree:",
                element.item_code,
                "item_id:",
                element.item_id
              );
              //running function handleAllBatch
              // if (t != 1) {
              element.is_all_batch = true;
              this.handleAllBatch(element, element.item_id, 99, this.ItFG);
              // console.log(">>>>>gogogoogo", element);
              // }
              // t--;
            });

            this.calculatePromotion = true;
          } else {
            this.$vs.notify({
              title: "Error",
              text: response.data.message,
              color: "danger",
              position: "top-right",
            });
          }
        });
    },
  },
  watch: {
    //check if status complete then set reason, note and accepted quantity disabled then set value accepted qty= quantity:
    "selectedStatus.ID": {
      handler(newVal) {
        if (newVal == 1) {
          this.disabledReason = true;
          this.disableRejectAndAccept = true;
        } else if (newVal == 2) {
          this.disabledReason = false;
          this.disableRejectAndAccept = false;
        } else if (newVal == 5 || newVal == 4) {
          this.disabledReason = true;
          this.disableRejectAndAccept = true;
        } else {
          this.disabledReason = false;
          this.disableRejectAndAccept = true;
        }
      },
    },
    //check set adjusted quantity each itemLine is value
  },
  computed: {
    // Computed property untuk Visit Photo URL
    visitPhotoUrl() {
      return this.imgVisit || this.sampleLocationData.visit_photo_url || null;
    },

    // Computed property untuk COD Photo URL
    codPhotoUrl() {
      return this.imgCOD || this.sampleLocationData.cod_photo_url || null;
    },

    // Computed property untuk POD Photo URL
    podPhotoUrl() {
      return this.imgPOD || this.sampleLocationData.pod_photo_url || null;
    },

    // Computed property untuk check apakah ada valid location data
    hasValidLocationData() {
      return (
        this.locationData.latitude !== null &&
        this.locationData.longitude !== null &&
        !isNaN(this.locationData.latitude) &&
        !isNaN(this.locationData.longitude)
      );
    },

    // Computed property untuk check apakah ada valid route data
    hasValidRouteData() {
      return (
        this.routeDataComputed.origin.latitude !== null &&
        this.routeDataComputed.origin.longitude !== null &&
        this.routeDataComputed.destination.latitude !== null &&
        this.routeDataComputed.destination.longitude !== null &&
        !isNaN(this.routeDataComputed.origin.latitude) &&
        !isNaN(this.routeDataComputed.origin.longitude) &&
        !isNaN(this.routeDataComputed.destination.latitude) &&
        !isNaN(this.routeDataComputed.destination.longitude)
      );
    },

    // Computed property untuk location data yang aktif
    locationData() {
      if (
        this.sampleLocationData.latitude !== null &&
        this.sampleLocationData.longitude !== null
      ) {
        return this.sampleLocationData;
      }
      return this.routeData.destination;
    },

    // Computed property untuk route data yang clean dan validated
    routeDataComputed() {
      return {
        origin: {
          latitude: parseFloat(this.routeData.origin.latitude) || null,
          longitude: parseFloat(this.routeData.origin.longitude) || null,
          accuracy: this.routeData.origin.accuracy,
          location_timestamp: this.routeData.origin.location_timestamp,
          location_address: this.routeData.origin.location_address,
        },
        destination: {
          latitude: parseFloat(this.routeData.destination.latitude) || null,
          longitude: parseFloat(this.routeData.destination.longitude) || null,
          accuracy: this.routeData.destination.accuracy,
          location_timestamp: this.routeData.destination.location_timestamp,
          location_address: this.routeData.destination.location_address,
        },
      };
    },

    // Computed property untuk menghitung jarak antara customer location dan visit location
    distanceBetweenCustomerAndVisit() {
      // Hitung jarak dari customer master data ke GPS visit actual
      const customerLat = this.customerLocation.latitude;
      const customerLng = this.customerLocation.longitude;
      const visitLat = this.routeData.origin.latitude; // origin adalah visit GPS actual
      const visitLng = this.routeData.origin.longitude;

      // Validasi data
      if (
        customerLat === null ||
        customerLng === null ||
        visitLat === null ||
        visitLng === null ||
        isNaN(customerLat) ||
        isNaN(customerLng) ||
        isNaN(visitLat) ||
        isNaN(visitLng)
      ) {
        return null;
      }

      // Haversine formula untuk menghitung jarak
      const R = 6371; // Earth's radius in kilometers
      const dLat = this.deg2rad(visitLat - customerLat);
      const dLon = this.deg2rad(visitLng - customerLng);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(customerLat)) *
          Math.cos(this.deg2rad(visitLat)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c;

      // Return dalam meter jika < 1km, kilometer jika >= 1km
      if (distance < 1) {
        return `${(distance * 1000).toFixed(2)} m`;
      }
      return `${distance.toFixed(2)} km`;
    },
  },
  filters: {
    formatDate(val) {
      return moment(val)
        .add(-7, "h")
        .utc()
        .local()
        .format("DD MMM YYYY HH:mm:ss");
    },
  },
};
</script>

<style>
.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.separator {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 20px 0;
}

.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #000;
}

.separator::before {
  margin-right: 10px;
}

.separator::after {
  margin-left: 10px;
}

.separator span {
  font-weight: bold;
}

/* Accepted Quantity Styles */
.accepted-quantity-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0;
}

.quantity-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(128, 128, 128, 0.15);
  border: 1px solid rgba(128, 128, 128, 0.3);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  max-width: fit-content;
}

.quantity-badge:hover {
  background: rgba(128, 128, 128, 0.2);
  border-color: rgba(128, 128, 128, 0.4);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.quantity-number {
  font-size: 16px;
  font-weight: 700;
  color: #666666;
  min-width: 20px;
  text-align: center;
}

.quantity-unit {
  font-size: 13px;
  font-weight: 600;
  color: #888888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: rgba(128, 128, 128, 0.1);
  padding: 2px 8px;
  border-radius: 4px;
}

.text-muted {
  color: #999;
  font-style: italic;
  text-align: center;
}

/* Alternative color schemes - you can swap these */
/* Green theme */
.quantity-badge.green-theme {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
}

/* Blue theme */
.quantity-badge.blue-theme {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

/* Orange theme */
.quantity-badge.orange-theme {
  background: linear-gradient(135deg, #7c797a 0%, #fee140 100%);
}

/* ========================================
   EPOD PHOTOS GRID - IMPROVED LAYOUT
   ======================================== */
.epod-photos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
}

.epod-photo-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.epod-photo-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.epod-photo-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: linear-gradient(to right, #f9fafb, #ffffff);
  border-bottom: 1px solid #e5e7eb;
}

.epod-photo-icon {
  font-size: 20px;
}

.epod-photo-title {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.epod-badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.epod-badge-green {
  background: #d1fae5;
  color: #065f46;
}

.epod-badge-yellow {
  background: #fef3c7;
  color: #92400e;
}

.epod-badge-blue {
  background: #dbeafe;
  color: #1e40af;
}

.epod-photo-wrapper {
  position: relative;
  height: 200px;
  overflow: hidden;
  cursor: pointer;
  background: #f9fafb;
}

.epod-photo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.epod-photo-wrapper:hover .epod-photo-img {
  transform: scale(1.05);
}

.epod-photo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.epod-photo-wrapper:hover .epod-photo-overlay {
  background: rgba(0, 0, 0, 0.5);
  opacity: 1;
}

.epod-zoom-icon {
  color: white;
  font-size: 32px;
}

.epod-overlay-text {
  color: white;
  font-size: 13px;
  font-weight: 500;
}

.epod-photo-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  background: #f9fafb;
  color: #9ca3af;
}

.epod-empty-icon {
  font-size: 40px;
  margin-bottom: 12px;
  color: #d1d5db;
}

.epod-empty-text {
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
}

/* ========================================
   EPOD MAP SECTION
   ======================================== */
.epod-map-section {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-top: 16px;
}

.epod-map-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: linear-gradient(to right, #f9fafb, #ffffff);
  border-bottom: 1px solid #e5e7eb;
}

.epod-map-controls {
  display: flex;
  gap: 8px;
  align-items: center;
}

.epod-map-content {
  padding: 16px;
  background: #f9fafb;
}

.epod-map-content > div {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Radius Status Indicator */
.epod-radius-status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  margin: 0 16px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.epod-radius-status.status-inside {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border: 1px solid #6ee7b7;
  color: #065f46;
}

.epod-radius-status.status-outside {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border: 1px solid #fca5a5;
  color: #991b1b;
}

.epod-radius-status .status-icon {
  font-size: 18px;
  display: flex;
  align-items: center;
}

.epod-radius-status .status-text {
  flex: 1;
  letter-spacing: 0.3px;
}

/* ========================================
   EPOD PHOTO MODAL - IMPROVED DESIGN
   ======================================== */
.epod-photo-modal {
  max-width: 90vw !important;
  max-height: 90vh !important;
  border-radius: 16px !important;
  overflow: hidden !important;
}

.epod-modal-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 70vh;
}

.epod-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(to right, #f9fafb, #ffffff);
}

.epod-modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.epod-close-btn {
  min-width: auto !important;
}

.epod-modal-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px;
  background: #f9fafb;
}

.epod-modal-image-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  min-height: 400px;
  max-height: 60vh;
  overflow: hidden;
}

.epod-modal-image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.epod-modal-controls {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;
}

.epod-modal-info {
  display: flex;
  justify-content: center;
}

.epod-info-badge {
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* ========================================
   RESPONSIVE ADJUSTMENTS
   ======================================== */
@media (max-width: 768px) {
  .epod-photos-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .epod-photo-wrapper,
  .epod-photo-empty {
    height: 180px;
  }

  .epod-modal-image-wrapper {
    min-height: 300px;
    max-height: 50vh;
  }

  .epod-modal-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .epod-modal-controls {
    flex-direction: column;
    width: 100%;
  }

  .epod-modal-controls button {
    width: 100%;
  }
}
</style>
